"use strict";

document.getElementById('svg-container').innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" style="width:0;height:0" visibility="hidden"><symbol id="svg-icon-about-1" viewBox="0 0 106 107"><path fill-rule="evenodd" clip-rule="evenodd" d="M36.832 19.287c-.456.398-3.758 5.13-3.859 5.53-.093.37.218.902.642 1.095.587.268.931-.042 2.368-2.127.757-1.1 1.431-1.982 1.499-1.961.172.052 2.205 3.004 4.133 6.001 3.936 6.12 6.427 11 7.224 14.15.856 3.385-.22 7.224-2.816 10.044-1.559 1.692-3.892 3.034-6.139 3.529-1.277.281-4.04.213-5.316-.131-4.936-1.332-8.4-5.502-8.79-10.58-.161-2.086.56-4.44 2.627-8.573a85.252 85.252 0 012.633-4.814c1.466-2.438 1.58-2.816.987-3.283-.398-.312-.824-.353-1.153-.11-.385.286-3.105 4.968-4.342 7.476-1.218 2.47-1.954 4.302-2.427 6.04-.346 1.272-.38 3.867-.07 5.262.57 2.555 1.865 4.97 3.63 6.766 1.055 1.072 3.14 2.576 4.004 2.888.52.188.535.248.16.585-.536.482-1.452 1.892-2.033 3.13-.846 1.8-1.18 3.27-1.195 5.262l-.012 1.628h-2.365c-2.334 0-2.37.005-2.691.326-.362.362-.397.57-.18 1.049.249.544.637.619 3.228.619h2.431l.166.564c.327 1.114 1.353 2.993 2.235 4.092.77.96 1.796 1.897 3.269 2.985l.36.266-1.466 1.727c-.806.95-1.499 1.85-1.539 1.999-.109.4.156.973.527 1.142.623.284.942.047 2.61-1.936l1.611-1.915 1.261.648c1.483.761 3.538 1.581 5.03 2.007.585.166 1.085.317 1.111.334.027.018-.147 1.071-.385 2.341-.487 2.588-.469 2.947.161 3.212 1.001.42 1.257.028 1.772-2.718.233-1.243.451-2.288.485-2.322.034-.034.417-.003.851.068 1.838.303 4.564.416 6.529.27 1.284-.095 1.979-.1 2.032-.013.045.072.188 1.105.32 2.294.138 1.256.317 2.288.428 2.46.237.372.77.514 1.195.32.605-.275.638-.583.338-3.151-.153-1.301-.264-2.379-.247-2.394.016-.015.721-.208 1.566-.428 2.041-.532 3.82-1.209 5.856-2.227l1.677-.84.958 2.02c.527 1.11 1.052 2.123 1.168 2.25.26.29.942.302 1.335.027.525-.368.391-.934-.766-3.245l-1.061-2.12.611-.42c.715-.492 2.595-2.065 3.628-3.034.708-.664.727-.673.997-.437.152.133.904.812 1.671 1.51 1.424 1.295 1.811 1.574 2.19 1.574.355 0 .867-.615.867-1.042 0-.41-.434-.879-2.672-2.889l-1.011-.907.579-.737c.336-.428.579-.879.579-1.073 0-.739-.76-1.233-1.38-.897-.17.093-.596.528-.944.967-3.628 4.565-9.035 8.08-14.7 9.556-2.701.704-4.335.911-7.165.91-4.68-.004-8.79-.99-12.877-3.09-4.333-2.225-6.555-4.471-7.674-7.756-1.286-3.78-.193-8.38 2.629-11.066l.577-.55 1.196.192c2.446.391 5.47-.058 7.75-1.151 1.675-.802 2.928-1.739 4.512-3.372a78.96 78.96 0 012.306-2.286c1.203-1.115 2.154-2.413 2.916-3.978.8-1.644 1.149-2.894 1.336-4.784.37-3.738 1.128-5.662 3.02-7.667 1.495-1.585 2.96-2.491 5.033-3.113 1.517-.456 4.082-.516 5.557-.131 3.048.795 5.225 2.488 7.278 5.661 2.847 4.4 4.38 9.701 4.38 15.15 0 4.354-1.008 8.77-2.822 12.363-.564 1.118-.494 1.725.234 2.001.604.23 1.042-.067 1.514-1.025.23-.466.438-.848.463-.848.026 0 .964.479 2.086 1.063 1.122.585 2.19 1.064 2.372 1.064.73 0 1.164-1.006.676-1.567-.128-.148-1.166-.76-2.306-1.36l-2.075-1.092.435-1.346c.459-1.425 1.12-4.22 1.124-4.75.005-.715.064-.723 2.412-.337 1.194.196 2.302.356 2.46.355.35-.004.841-.589.841-1.003 0-.713-.307-.85-2.926-1.303l-2.457-.424.044-.995c.074-1.656-.36-6.028-.714-7.185-.052-.17.376-.325 2.297-.83 2.51-.663 2.826-.835 2.826-1.543 0-.443-.497-.94-.94-.939-.177 0-1.3.261-2.494.58-2.158.575-2.172.577-2.285.298a58.898 58.898 0 01-.533-1.476c-.33-.94-1.144-2.722-2.223-4.864-.022-.043.737-.568 1.688-1.167 2.235-1.408 2.534-1.663 2.534-2.16 0-.429-.51-1.045-.865-1.045-.299 0-.703.225-2.72 1.51l-1.772 1.131-.398-.556c-1.671-2.342-3.847-4.008-6.391-4.896-.888-.31-1.073-.423-1.048-.637.017-.144.239-1.191.494-2.328.254-1.137.426-2.171.38-2.298-.16-.456-.481-.697-.925-.697-.644 0-.91.351-1.173 1.545-.127.575-.36 1.629-.519 2.34l-.287 1.294L65 28.88c-2.25.086-3.625.446-5.727 1.498l-.946.474-1.953-1.613c-2.083-1.72-2.397-1.862-3.008-1.367-.35.283-.408.943-.114 1.297.103.125.876.795 1.716 1.489.84.694 1.577 1.304 1.637 1.356.06.053-.229.447-.64.877-2.08 2.172-3.226 4.819-3.53 8.152-.17 1.853-.387 2.85-.93 4.257-.226.585-.424 1.065-.44 1.065-.016 0-.005-.739.025-1.64.048-1.445.012-1.809-.297-3.047-.9-3.592-3.473-8.717-7.556-15.048-1.699-2.634-4.527-6.712-5.035-7.26-.428-.462-.903-.49-1.371-.082zm39.362.956c-2.94 1.049-3.794 4.93-1.56 7.097.823.798 1.617 1.137 2.797 1.193 1.317.062 2.284-.29 3.163-1.15.963-.943 1.282-1.707 1.285-3.08.001-.873-.063-1.268-.281-1.743-.411-.892-1.152-1.645-2.073-2.105-.692-.346-.952-.403-1.817-.398-.554.003-1.236.087-1.514.186zm2.82 2.192c.51.364.935 1.203.939 1.86.008 1.211-1.068 2.268-2.308 2.268-2.017 0-3.063-2.447-1.65-3.86.568-.568.837-.662 1.774-.62.59.028.92.12 1.244.352zM36.328 35.668c-1.285.472-2.088 1.62-2.197 3.14l-.065.911h-.697c-2.264 0-3.878 1.911-3.404 4.03.344 1.538 1.492 2.48 3.154 2.586l.983.063v.626c0 .344.082.899.182 1.232.747 2.482 3.93 3.17 5.647 1.22.59-.67.816-1.327.816-2.364v-.748l.83-.002c1.034-.002 1.978-.41 2.61-1.13.592-.675.813-1.238.813-2.071 0-.951-.229-1.624-.766-2.252-.646-.754-1.368-1.087-2.523-1.162l-.964-.063v-.731c0-1-.222-1.66-.778-2.31-.884-1.032-2.388-1.435-3.64-.975zm24.1.142c-.902.243-1.444.575-2.073 1.271-.783.866-1.057 1.6-1.059 2.837-.001.871.061 1.197.345 1.803 1.248 2.661 4.661 3.34 6.788 1.35 1.638-1.531 1.859-3.924.525-5.688-.622-.823-1.37-1.325-2.354-1.582-.936-.243-1.236-.242-2.172.01zm-22.063 2.038c.376.376.389.431.389 1.668 0 1.416.197 2.015.7 2.124.163.035.885.08 1.604.101 1.247.036 1.322.055 1.628.41.47.548.442 1.321-.068 1.83-.375.376-.432.39-1.655.39-.697 0-1.412.066-1.59.147-.486.22-.62.665-.62 2.061 0 1.223-.013 1.28-.388 1.655-.42.421-.944.502-1.526.237-.536-.244-.744-.867-.744-2.233 0-1.113-.027-1.243-.326-1.542-.303-.303-.42-.326-1.675-.326h-1.348l-.452-.452c-.613-.613-.613-1.14 0-1.754l.452-.452h1.325c1.123 0 1.375-.04 1.662-.266.32-.252.341-.344.384-1.739.045-1.472.045-1.472.479-1.86.593-.53 1.239-.529 1.769.001zm24.489.224c.557.368 1.013 1.199 1.013 1.846 0 .852-.708 1.885-1.498 2.184-1.47.557-3.155-.593-3.145-2.146.004-.53.391-1.41.767-1.745.76-.675 1.96-.733 2.863-.139zm4.651 7.212c-2.16.8-3.621 2.757-3.74 5.006-.157 3.004 1.86 5.474 4.849 5.937 2.336.361 4.754-.951 5.84-3.17 1.362-2.784.138-6.192-2.703-7.526-.793-.373-1.059-.428-2.23-.462-1.052-.031-1.471.013-2.016.215zm3.229 1.941c.762.319 1.431.928 1.851 1.687.337.607.392.849.392 1.704 0 .869-.052 1.09-.412 1.727-.95 1.685-2.919 2.386-4.663 1.66-.684-.286-1.58-1.207-1.903-1.956-.244-.566-.286-.86-.235-1.644.093-1.46.825-2.517 2.163-3.127.662-.302 2.142-.328 2.807-.05zM22.14 54.586c-1.266.416-2.241 1.259-2.775 2.397-.464.99-.49 2.55-.06 3.49.982 2.138 3.583 3.162 5.632 2.217 1.048-.483 1.652-1.068 2.151-2.083.378-.768.434-1.014.427-1.882-.008-1.208-.309-1.963-1.138-2.862-.83-.9-1.683-1.295-2.908-1.345-.548-.023-1.146.008-1.329.068zm1.952 2.019c.532.201.969.638 1.252 1.253.322.697.314 1.183-.03 1.894-.766 1.581-2.961 1.755-3.934.31-.607-.9-.555-1.974.133-2.757.682-.778 1.668-1.045 2.579-.7zm21.436 3.65c-.732.226-1.662.993-1.781 1.469-.103.409.188.929.633 1.132.339.154.7.03 1.404-.483.703-.511 1.32-.43 2.184.29.473.393.776.394 1.233 0 .574-.493.503-1.076-.208-1.707-.934-.828-2.213-1.087-3.465-.7zm17.543-.008c-.672.216-1.662.995-1.794 1.412-.127.402.175 1.006.59 1.177.411.17.73.07 1.46-.463.675-.49 1.365-.404 2.17.273.476.4.758.413 1.216.053.254-.2.35-.398.35-.72 0-1.283-2.293-2.278-3.991-1.732zm-9.151.147c-2.28.613-4.188 2.574-4.511 4.637-.262 1.67.454 3.286 1.749 3.946.488.25.67.266 1.81.175 1.35-.108 2.62-.12 5.011-.044 1.466.045 1.489.042 2.046-.353.327-.23.737-.705.977-1.13.377-.667.412-.833.411-1.926 0-1.05-.048-1.294-.39-1.993-1.249-2.568-4.402-4.038-7.103-3.312zm3.208 2.18c1.814.853 2.79 2.707 2.144 4.07-.263.553-.604.655-1.692.506-1.04-.144-3.161-.142-4.557.002-1.073.111-1.083.11-1.31-.236-.972-1.485.2-3.726 2.352-4.496.888-.317 2.2-.251 3.063.154zM22.632 73.727c-1.011.407-1.75 1.1-2.245 2.105-.379.77-.439 1.028-.439 1.893 0 .866.06 1.124.439 1.893.746 1.517 2.108 2.36 3.81 2.36 1.73 0 3.063-.825 3.82-2.362.387-.788.436-1.01.43-1.955-.006-.888-.067-1.18-.365-1.758-.496-.96-1.017-1.515-1.845-1.966-.94-.512-2.614-.61-3.605-.21zm2.755 2.04c.614.35 1.14 1.244 1.14 1.937 0 1.236-1.066 2.28-2.326 2.28-1.25 0-2.326-1.044-2.326-2.259 0-1.715 1.99-2.824 3.512-1.958z" fill="#04A061"/></symbol><symbol id="svg-icon-about-2" viewBox="0 0 107 106"><path fill-rule="evenodd" clip-rule="evenodd" d="M73.76 18.192c-2.212.418-4.34 1.315-6.095 2.57-.5.358-3.89 3.63-7.535 7.273-5.751 5.748-6.627 6.682-6.627 7.07 0 .392 1.26 1.704 9.96 10.379 8.7 8.674 10.017 9.93 10.41 9.93.39 0 1.326-.873 7.091-6.607 3.654-3.633 6.946-7.024 7.315-7.535.931-1.287 1.958-3.515 2.36-5.121.481-1.916.481-5.013 0-6.929-.4-1.597-1.423-3.822-2.36-5.13-1.457-2.037-3.843-3.922-6.29-4.97-2.336-1-5.794-1.39-8.229-.93zm6.174 2.645a12.431 12.431 0 018.408 8.83c.427 1.665.428 4.228 0 5.889-.344 1.342-1.094 3.02-1.837 4.114-.269.395-2.366 2.606-4.661 4.913l-4.173 4.194-8.751-8.724-8.752-8.724 3.522-3.527c4.27-4.278 5.388-5.256 6.9-6.037 2.876-1.487 6.396-1.837 9.344-.928zm-49.31 4.573c-.379.106-.924.338-1.211.517-.87.54-6.588 6.389-6.978 7.137-.5.961-.502 2.665-.003 3.608.498.94 1.545 2.004 2.478 2.52.684.377.963.441 1.935.441.965 0 1.253-.064 1.911-.428 1.014-.56 6.852-6.4 7.346-7.349.5-.961.502-2.665.003-3.608-1.146-2.163-3.512-3.388-5.48-2.838zm13.185 1.207c-.743.234-2.011 1.543-2.239 2.312-.42 1.416-.124 2.545.947 3.612 1.532 1.528 3.476 1.528 5.008 0 1.533-1.528 1.533-3.466 0-4.994-1.066-1.062-2.306-1.373-3.716-.93zm-10.54 1.908c.72.717.77.817.77 1.52 0 .736-.023.775-1.173 1.922l-1.174 1.17-1.55-1.545-1.55-1.545 1.058-1.072c1.22-1.237 1.448-1.366 2.256-1.281.469.05.755.224 1.363.83zm12.592.682c.751.749.219 2.045-.84 2.045-.295 0-.606-.137-.84-.37a1.215 1.215 0 01-.372-.838c0-.294.138-.604.372-.837.234-.234.545-.371.84-.371.295 0 .605.137.84.37zM28.438 33.37l1.512 1.515-1.144 1.118c-1.637 1.598-2.193 1.658-3.533.384-.733-.697-.776-.78-.776-1.498 0-.745.024-.785 1.132-1.898.623-.625 1.17-1.136 1.215-1.136.045 0 .763.682 1.594 1.515zm46.538 18.077c-.517.52-1.01.946-1.096.946-.198 0-17.347-17.09-17.347-17.287 0-.08.424-.575.944-1.097l.944-.95 8.748 8.72 8.748 8.722-.94.946zm-38.44-12.87l-.824.833 1.17 1.167 1.171 1.166.869-.865.868-.866-1.13-1.134c-.62-.623-1.167-1.133-1.214-1.133-.046 0-.456.374-.91.832zm11.053.121c-1.321.37-2.623 1.475-3.349 2.845-.496.936-.493 2.643.006 3.601.495.949 6.332 6.788 7.346 7.349.658.364.947.428 1.911.428.972 0 1.251-.063 1.935-.441.933-.516 1.98-1.58 2.478-2.52.5-.942.498-2.647-.003-3.608-.535-1.026-6.4-6.86-7.363-7.324-.946-.456-2.064-.58-2.961-.33zm1.794 2.433c.225.118.851.663 1.391 1.21l.982.995-1.55 1.544-1.55 1.546-1.173-1.17c-1.148-1.145-1.174-1.188-1.174-1.917 0-.645.07-.82.53-1.3 1.032-1.082 1.736-1.333 2.544-.908zm-18.903 1.19c-.743.234-2.011 1.543-2.24 2.312-.419 1.416-.123 2.545.948 3.612 1.532 1.528 3.476 1.528 5.008 0 1.48-1.476 1.525-3.353.116-4.915-.98-1.087-2.396-1.46-3.832-1.009zm2.052 2.59c.234.233.372.543.372.837 0 .294-.138.604-.372.838-.234.233-.545.37-.84.37-.295 0-.606-.137-.84-.37a1.215 1.215 0 01-.372-.838c0-.294.138-.604.372-.837.234-.234.545-.37.84-.37.295 0 .605.136.84.37zm22.187 1.37c1.108 1.112 1.132 1.152 1.132 1.897 0 .718-.043.801-.776 1.498-1.34 1.274-1.896 1.214-3.533-.384l-1.144-1.118 1.512-1.515c.831-.833 1.549-1.515 1.594-1.515.045 0 .592.511 1.215 1.136zm-35 2.082c-1.321.369-2.623 1.475-3.349 2.845-.496.935-.493 2.643.006 3.6.495.95 6.332 6.79 7.346 7.35.658.363.947.428 1.911.428.973 0 1.251-.064 1.935-.441.933-.516 1.98-1.58 2.478-2.52.5-.943.498-2.647-.003-3.608-.535-1.026-6.399-6.86-7.363-7.325-.946-.455-2.064-.58-2.961-.33zm21.969 1.388l-1.13 1.134.868.866.869.865 1.17-1.166 1.171-1.168-.825-.832c-.453-.458-.862-.833-.91-.833-.046 0-.592.51-1.213 1.134zm-20.175 1.045c.225.118.851.663 1.391 1.21l.982.994-1.55 1.545-1.55 1.545-1.173-1.17c-1.148-1.144-1.174-1.188-1.174-1.916 0-.646.07-.82.53-1.3 1.032-1.082 1.736-1.333 2.544-.908zm13.77 4.584c-.392.398-.713.79-.713.873 0 .082.511.656 1.137 1.275l1.137 1.126.867-.864.867-.865-1.13-1.133c-.62-.624-1.201-1.134-1.29-1.134-.088 0-.482.325-.875.722zm-8.434.565c1.108 1.112 1.132 1.153 1.132 1.898 0 .718-.043.801-.776 1.498-1.34 1.274-1.896 1.214-3.533-.384l-1.144-1.118 1.512-1.515c.832-.833 1.549-1.515 1.594-1.515.045 0 .592.511 1.215 1.136zM46.597 57l-.38.379.051 9.248c.05 8.92.062 9.29.376 10.404 1.51 5.355 5.38 9.206 10.624 10.568 1.658.43 4.155.527 5.876.227 5.742-1 10.136-5.034 11.759-10.795.314-1.114.327-1.484.376-10.404l.05-9.248L74.95 57l-.38-.378H46.977l-.379.378zm26.294 3.246v1.209H48.656v-2.417h24.235v1.208zm-.037 9.476c-.06 6.208-.061 6.224-.87 8.377-.436 1.164-1.583 2.874-2.645 3.945-4.65 4.69-12.322 4.724-17.036.077-1.137-1.12-2.284-2.804-2.74-4.022-.809-2.153-.81-2.17-.87-8.377l-.056-5.851H72.91l-.056 5.851z" fill="#04A061"/></symbol><symbol id="svg-icon-about-3" viewBox="0 0 106 107"><path fill-rule="evenodd" clip-rule="evenodd" d="M71.27 19.217c-3.985 1.022-6.83 4.44-7.064 8.488-.062 1.077.027 1.755.82 6.276.488 2.788.972 5.472 1.075 5.965a9.28 9.28 0 007.344 7.252c2.051.395 3.883.134 5.864-.837 1.04-.51 1.444-.806 2.325-1.7.586-.595 1.264-1.42 1.507-1.835.894-1.527 1.45-3.868 1.275-5.374-.193-1.671-.489-3.02-.648-2.958-.09.034-.502.105-.917.157-.414.052-.778.135-.808.183-.03.05.033.538.14 1.085.676 3.455-.306 6.28-2.804 8.07-1.336.957-2.482 1.32-4.185 1.323-1.11.002-1.575-.06-2.273-.3-2.178-.752-3.937-2.503-4.623-4.604-.323-.991-1.994-10.412-2.098-11.83-.24-3.297 2.258-6.617 5.572-7.401 2.45-.58 4.931.129 6.758 1.93 1.146 1.13 1.75 2.345 2.137 4.294.15.758.281 1.388.29 1.401.032.044 1.812-.315 1.875-.378.08-.08-.27-1.944-.545-2.913-.764-2.68-3.168-5.13-5.964-6.078-1.416-.48-3.652-.575-5.052-.216zm-45.462 1.311c-.383.333-.697.655-.697.716 0 .06.934 1.18 2.076 2.489a3019.14 3019.14 0 012.263 2.594c.164.19.09.314-.63 1.067-1.503 1.568-2.814 3.697-3.525 5.72l-.305.867-2.198.036-2.198.037v1.987l1.96.037c1.768.033 1.958.06 1.948.27-.006.129-.021 2.305-.033 4.836l-.022 4.601H19v2h5.447V58.724H20.594v2H24.447v2.651c0 3.119.304 5.193 1.016 6.92.054.13-.637.167-3.197.167H19v2H26.515l.25.434c.517.893 1.482 2.068 2.571 3.131l1.125 1.097-1.58 1.514c-.868.833-1.784 1.696-2.035 1.92l-.458.405.64.752c.352.413.667.751.701.751.034 0 1.055-.955 2.268-2.123l2.206-2.123.9.456c1.59.803 4.126 1.523 5.37 1.523h.454V87h1.988l.035-3.368.036-3.368.93-.102c1.628-.179 3.591-.79 5.155-1.608l.771-.402.956.927c.526.51 1.633 1.58 2.46 2.376l1.505 1.448.726-.72.727-.718-.637-.597c-.35-.328-1.4-1.324-2.334-2.214l-1.698-1.617 1.207-1.185c.663-.652 1.482-1.591 1.82-2.088l.614-.902h8.323V70.86h-7.269l.371-1.053c.657-1.862.8-2.82.88-5.85l.075-2.834h4.481v-2h-4.516v-2.135h-1.968l-.057 4.835c-.055 4.692-.067 4.874-.402 6.13-.669 2.511-1.816 4.52-3.608 6.319-1.798 1.806-3.817 2.965-6.293 3.613-1.048.274-1.625.34-3.083.352-1.004.008-2.144-.06-2.59-.156-5.337-1.135-9.229-4.809-10.734-10.132-.288-1.02-.29-1.076-.328-15.948-.043-16.541-.06-16.16.816-18.5.89-2.38 2.648-4.705 4.726-6.252 1.087-.808 3.03-1.754 4.368-2.125a13.41 13.41 0 0113.118 3.505c1.793 1.808 2.933 3.805 3.612 6.324l.349 1.294.05 6.97.05 6.969H55.532v-1.868h5.979v-2h-5.979v-4.452c0-2.448-.036-4.638-.082-4.865l-.082-.414 2.307-.036 2.308-.037.039-.964.039-.964-2.485-.036-2.484-.037-.363-1.083c-.703-2.103-1.837-4.09-3.16-5.538-.377-.413-.686-.785-.686-.825 0-.04 1.046-1.263 2.325-2.716l2.326-2.642-.674-.634c-.371-.348-.725-.633-.787-.633-.061 0-1.135 1.17-2.386 2.6-1.251 1.431-2.326 2.602-2.389 2.602-.062 0-.616-.317-1.23-.705-4.69-2.956-10.86-3.071-15.714-.293-.579.33-1.095.586-1.146.566-.05-.02-1.062-1.146-2.246-2.503a370.728 370.728 0 00-2.304-2.627c-.117-.123-.314-.02-.85.445zm14.912 9.234c-2.284.659-3.997 2.383-4.789 4.82-.333 1.023-.306 2.852.059 4.01.794 2.522 3.053 4.433 5.696 4.82.89.13 1.233.12 2.167-.065 4.646-.919 7.035-5.78 4.956-10.082-.478-.988-2.008-2.524-2.992-3.004-1.583-.771-3.503-.96-5.097-.5zm32.761.028c-.32.063-.606.139-.635.168-.028.029.02.485.106 1.013.144.872.184.955.436.895.153-.037.563-.108.91-.159.349-.05.665-.142.703-.204.038-.062.001-.506-.082-.985-.169-.975-.173-.977-1.438-.728zm8.687.824c-.438.073-.818.152-.844.174-.026.023.029.465.121.983.157.885.189.942.512.937.423-.007 1.46-.203 1.549-.293.125-.125-.248-1.969-.394-1.952-.08.01-.506.077-.944.15zm-37.506 1.328a4.989 4.989 0 012.402 2.353c.4.816.431.979.431 2.217 0 1.187-.04 1.42-.364 2.08-.94 1.921-3.07 3.116-5.102 2.861-.936-.117-2.423-.873-3.018-1.535a5.321 5.321 0 01-1.267-2.656c-.394-2.455.926-4.594 3.434-5.563.78-.302 2.575-.176 3.484.243zm31.66 1.34c-.438.073-.817.151-.843.174-.026.022.029.465.12.983.189 1.057.151 1.035 1.377.788.757-.152.763-.157.69-.567-.04-.227-.113-.667-.161-.98-.048-.311-.154-.558-.236-.55-.082.01-.508.078-.946.151zm-3.89.697c-.458.091-.858.19-.886.22-.046.045.038.576.264 1.666.055.26.108.274.692.168 1.35-.244 1.274-.181 1.173-.958-.118-.904-.217-1.298-.322-1.278-.047.009-.461.09-.92.182zM46.926 47.286l.039.967.963.039.963.04v-2.013h-2.004l.039.967zm-14.048 1.913c-.766.273-1.406.85-1.854 1.674-.325.597-.389.867-.389 1.648 0 .783.064 1.05.394 1.657 1.411 2.593 5.078 2.444 6.294-.257.308-.682.358-1.762.12-2.56-.217-.728-1.1-1.687-1.898-2.06-.775-.362-1.825-.402-2.667-.102zm2.36 2.31a1.5 1.5 0 01-.43 2.346c-.608.317-1.128.25-1.65-.21-.573-.506-.719-1.113-.419-1.748.474-1.003 1.77-1.205 2.498-.388zm11.688.445l.039.967.963.04.963.038v-2.012h-2.004l.039.967zm6.615 1.773v1.14l.963-.04.963-.039.039-1.1.038-1.1H53.54v1.14zm22.732 3.804c-1.031.185-2.448.705-3.308 1.216-1.057.627-2.549 2.148-3.184 3.244-.617 1.066-4.294 11.107-4.554 12.44-.099.502-.137 1.353-.095 2.134.126 2.394 1.007 4.386 2.69 6.091 1.084 1.097 2.23 1.807 3.72 2.305.932.311 1.274.355 2.79.355 1.498 0 1.86-.045 2.745-.34 2.971-.995 4.934-2.938 6.096-6.033.288-.768.524-1.445.524-1.505 0-.11-1.719-.761-1.798-.682-.023.023-.29.687-.593 1.475-.852 2.215-1.944 3.48-3.817 4.42-4.715 2.37-10.384-1.227-10.396-6.594a7.688 7.688 0 01.19-1.611c.312-1.204 3.76-10.622 4.158-11.36.201-.372.729-1.043 1.173-1.489a7.181 7.181 0 0110.286.045c.982 1.004 1.606 2.151 1.936 3.559.312 1.331.196 2.627-.387 4.338-.26.76-.456 1.396-.438 1.415.018.018.434.184.926.37.663.251.908.295.95.17.032-.091.208-.573.39-1.07 1.047-2.846.962-5.244-.28-7.826-.508-1.059-.79-1.446-1.752-2.412-1.747-1.754-3.65-2.6-6.128-2.726-.62-.031-1.45 0-1.844.07zm-45.05 3.126v1h1.992v-2h-1.992v1zm10.1-.128c-1.526.43-2.693 1.418-3.379 2.862-.375.79-.411.985-.411 2.201 0 1.16.045 1.43.345 2.068.511 1.087 1.443 2.049 2.484 2.563.83.41.972.438 2.283.438 1.276 0 1.466-.034 2.192-.391a5.206 5.206 0 001.242-8.545c-1.273-1.184-3.136-1.652-4.757-1.196zm2.736 2.172c1.111.574 1.701 1.553 1.702 2.825.001 1.955-1.44 3.316-3.364 3.176-2.571-.187-3.877-3.303-2.177-5.193 1.04-1.156 2.55-1.474 3.839-.808zm-12.836 2.625v1h1.992v-2h-1.992v1zm44.766 3.476c-.16.481-.27.893-.243.915.082.071 1.58.61 1.694.61.118 0 .677-1.377.677-1.67 0-.17-1.27-.73-1.654-.73-.108 0-.303.36-.474.875zm-3.174 2.892c-.152.459-.269.894-.26.968.015.107 1.454.722 1.71.73.142.005.69-1.757.58-1.858-.1-.094-1.57-.673-1.704-.673-.028 0-.175.375-.326.834zm4.049.62c-.112.18-.606 1.555-.606 1.683 0 .131 1.695.808 1.79.713.025-.026.196-.447.38-.934l.331-.887-.921-.33c-.507-.181-.946-.291-.975-.244zm6.32.789c-.174.338-.584 1.638-.53 1.679.15.115 1.726.64 1.774.591.032-.032.207-.455.388-.94.373-.994.457-.861-.82-1.31-.651-.23-.704-.232-.812-.02z" fill="#04A061"/></symbol><symbol id="svg-icon-about-4" viewBox="0 0 97 97"><path fill-rule="evenodd" clip-rule="evenodd" d="M46.294 14.178c-4.769.872-8.66 4.514-9.967 9.33-.418 1.539-.418 4.576 0 6.164.345 1.315 1.08 2.936 1.935 4.266a22.863 22.863 0 012.237 4.636c.466 1.35.998 3.65.998 4.317v.344H36.96c-4.238 0-4.56.017-4.844.25-.424.345-.424 1.15 0 1.496.295.24.99.249 21.605.249h21.3v.577c0 1.058-.528 2.268-1.476 3.383-.457.538-.472 1.003-.047 1.431.507.511.946.43 1.647-.306C76.279 49.124 77 47.292 77 45.596c0-.943-.262-1.49-.966-2.016-.37-.276-.46-.279-10.46-.314l-10.087-.036.002-.43c.002-.716.6-3.143 1.123-4.552a21.79 21.79 0 012.077-4.242c.938-1.508 1.622-3.012 1.97-4.334.416-1.587.416-4.617-.001-6.183-.526-1.973-2.268-5.033-3.121-5.483-.634-.335-1.39.144-1.39.88 0 .178.233.628.518 1 1.996 2.609 2.743 5.53 2.2 8.59-.245 1.373-.83 2.82-1.707 4.22-1.914 3.058-3.118 6.199-3.562 9.293l-.169 1.18-4.912.035c-3.867.027-4.923-.001-4.959-.133a63.456 63.456 0 01-.332-1.83c-.506-2.93-1.53-5.549-3.245-8.299-1.544-2.475-1.973-3.852-1.973-6.328 0-2.028.198-2.864 1.134-4.78.587-1.203.842-1.555 1.881-2.607 3.002-3.038 6.895-3.99 10.855-2.655.764.257 1.493.468 1.62.468.404 0 .827-.585.78-1.078-.052-.543-.54-.907-1.767-1.318-1.91-.64-4.285-.818-6.215-.466zM21.239 43.424c-.218.098-.573.367-.79.6-.348.372-.4.532-.441 1.378-.148 2.964 1.846 5.835 4.858 6.996.824.318 1.008.334 4.39.383 1.942.028 3.53.065 3.53.083 0 .018-.267.507-.595 1.086-2.552 4.507-3.098 10.208-1.452 15.168 2.139 6.445 7.374 11.112 14.1 12.57 1.919.415 5.383.416 7.297.002 3.976-.862 7.3-2.727 9.986-5.605 4.941-5.291 6.403-12.932 3.78-19.752a21.644 21.644 0 00-1.108-2.383c-.328-.58-.596-1.073-.596-1.097 0-.024 1.369-.044 3.042-.044h3.041l.324-.326c.389-.392.415-.861.072-1.288l-.253-.314-22.217-.066-22.217-.067-.783-.37c-1.917-.904-3.242-2.773-3.242-4.57v-.578h3.215c3.054 0 3.233-.014 3.564-.276.454-.36.474-1.02.042-1.43-.298-.281-.392-.289-3.728-.284-2.566.004-3.523.05-3.82.184zM38.243 53.64c-1.534 1.618-2.654 3.66-3.308 6.034-.328 1.189-.361 1.52-.36 3.507.001 1.8.052 2.397.284 3.324 1.483 5.919 6.616 10.359 12.407 10.73 1.514.098 1.886-.074 1.886-.873 0-.76-.301-.958-1.677-1.098-.638-.065-1.497-.205-1.908-.31-4.146-1.07-7.517-4.415-8.712-8.648-.405-1.436-.435-4.564-.058-5.973.631-2.356 1.809-4.356 3.522-5.979.587-.557 1.123-1.013 1.19-1.013.066 0 .12.647.12 1.438 0 1.556.176 2.791.482 3.387.332.647 1.124 1.43 1.82 1.8l.668.356h7.787l.668-.355c.696-.37 1.488-1.154 1.82-1.8.306-.597.481-1.832.481-3.388 0-.79.055-1.438.121-1.438.293 0 2.323 2.123 2.974 3.11 1.293 1.957 1.91 3.882 2.011 6.264.147 3.477-1.05 6.582-3.483 9.036-1.113 1.123-2.096 1.803-3.692 2.554-1.359.64-1.617.934-1.4 1.595.178.546.704.772 1.328.57 1.05-.34 2.699-1.224 3.7-1.983 2.259-1.715 3.916-4.045 4.86-6.834 1.59-4.696.423-10.273-2.901-13.867l-.904-.977h3.699l.472.649c2.24 3.072 3.44 7.709 2.984 11.518-.93 7.77-6.622 13.74-14.192 14.89-8.682 1.319-16.998-4.526-18.82-13.228-.381-1.82-.415-4.82-.074-6.552.435-2.204 1.546-4.85 2.744-6.535l.527-.742h3.723l-.789.831zm15.067 1.23c0 2.195-.11 2.584-.9 3.178-.358.268-.52.28-3.918.28-3.396 0-3.56-.012-3.916-.28-.759-.57-.897-1.008-.947-3.015-.025-1.008-.011-1.921.03-2.03.065-.17.728-.192 4.863-.162l4.788.035v1.994z" fill="#04A061"/></symbol><symbol id="svg-icon-about-5" viewBox="0 0 107 106"><path fill-rule="evenodd" clip-rule="evenodd" d="M51.259 12.168c-.72.157-1.36.748-1.36 1.255 0 .45.622 1.089 1.174 1.207 1 .215 2.416 2.025 2.15 2.75-.039.106-.415.237-.835.29-2.302.294-3.776 1.478-4.456 3.58-.181.56-.33 1.255-.33 1.544 0 .527 0 .528-1.662 1.049-3.589 1.125-7.303 3.34-10.06 6-2.116 2.043-3.522 3.948-4.847 6.568-1.248 2.47-1.827 4.048-2.253 6.144-.154.762-.295 1.408-.312 1.435-.017.028-.51.15-1.096.269-1.448.295-2.231.717-3.114 1.676-1.5 1.628-1.626 3.107-.552 6.495.39 1.233.876 2.559 1.079 2.946.792 1.514 2.45 2.81 4.117 3.22l.744.182.193 1.182c.578 3.545 3.078 6.944 6.424 8.733.738.394 1.94 1.07 2.67 1.5l1.33.782-1.172.53c-2.076.938-3.943 2.249-5.769 4.05-2.638 2.602-3.25 3.732-2.447 4.517.244.238.504.316.935.28.524-.043.705-.187 1.475-1.17 2.248-2.87 5.179-4.993 8.51-6.163l1.003-.352 1.352.664a21.64 21.64 0 009.691 2.246c3.316 0 6.039-.631 9.144-2.12l1.682-.806 1.026.362c4.581 1.621 8.4 4.998 10.379 9.179 1.404 2.968 2.143 7.298 1.443 8.456-.502.83-1.025.948-4.188.948-2.776 0-2.87.011-3.216.371-.505.525-.471 1.28.076 1.7.4.308.647.332 3.334.332 3.59 0 4.293-.164 5.419-1.263 1.117-1.09 1.39-1.989 1.267-4.172a19.773 19.773 0 00-3.83-10.602c-1.893-2.567-5.236-5.28-7.972-6.47-.607-.264-1.105-.52-1.107-.57-.006-.117 2.242-1.412 3.605-2.077 4.079-1.99 6.71-5.197 7.39-9.008l.191-1.076.681-.177c1.673-.434 3.292-1.736 4.091-3.29.221-.43.707-1.78 1.08-3 1.033-3.38.893-4.77-.648-6.417-.89-.95-1.982-1.498-3.283-1.649-.448-.051-.858-.161-.91-.244-.053-.083-.205-.667-.338-1.299-.608-2.873-2.007-6.203-3.614-8.597-2.828-4.215-7.165-7.72-11.826-9.557-.99-.39-1.748-.78-1.736-.894.011-.111.101-.617.2-1.125.266-1.368-.118-2.04-1.163-2.04-.651 0-.961.365-1.212 1.426-.346 1.459-.816 2.332-1.84 3.411-1.249 1.317-2.24 1.793-3.718 1.784-1.837-.011-3.097-.744-3.796-2.21-.693-1.453-.413-3.277.65-4.233.3-.27.796-.445 1.682-.596 1.508-.256 2.26-.748 2.73-1.785.389-.857.313-1.638-.276-2.88l-.396-.836.82.305c.933.346 1.728.898 2.715 1.886.798.8 1.345.882 1.95.29.694-.677.553-1.217-.623-2.378-.564-.558-1.442-1.244-1.952-1.526-1.767-.977-4.545-1.389-6.493-.963zm-2.905 14.096c.46.867 1.745 2.07 2.732 2.556 2.87 1.414 6.02.797 8.52-1.667l1.155-1.139.846.289c5.355 1.827 10.28 5.968 12.897 10.846 1.035 1.927 1.556 3.272 2.1 5.422.575 2.27.606 5.364.093 9.138a114.877 114.877 0 00-.543 4.806c-.251 2.994-.44 3.911-1.064 5.206-1.112 2.303-2.856 3.828-6.314 5.524-.764.375-2.388 1.332-3.61 2.128-4.234 2.759-6.718 3.626-10.754 3.753-2.09.066-2.721.026-4.184-.267-2.891-.578-5.124-1.55-8.026-3.493-.85-.568-2.4-1.5-3.444-2.071-2.348-1.283-3.251-1.923-4.193-2.974-1.472-1.644-2.148-3.316-2.473-6.124a305.318 305.318 0 00-.82-6.088c-.489-3.4-.582-4.458-.51-5.767.293-5.335 2.536-10.347 6.392-14.284 1.85-1.889 3.748-3.292 6.002-4.435 1.43-.725 4.333-1.848 4.812-1.862.065-.002.239.225.386.503zm-5.797 16.644c-1.744.335-3.588 1.72-4.37 3.28-.515 1.026-.548 1.721-.101 2.157.401.392 1.346.427 1.657.06.121-.142.409-.626.638-1.075 1.444-2.82 5.427-2.788 6.935.057.256.483.587.968.735 1.078.7.518 1.849-.097 1.849-.989 0-1.218-1.627-3.244-3.214-4.002-1.4-.67-2.68-.845-4.13-.566zm19.321.045c-1.258.284-2.207.804-3.148 1.722-.847.827-1.606 2.186-1.609 2.881-.002.608.657 1.144 1.33 1.08.562-.052.545-.034 1.657-1.778.635-.997 1.852-1.618 3.162-1.614 1.58.005 2.734.748 3.56 2.294.674 1.264 1.82 1.489 2.362.465.242-.458.242-.553-.004-1.182-1.123-2.871-4.295-4.55-7.31-3.868zm-33.638 3.85c0 .455.524 5.07.812 7.149.164 1.189.274 2.189.243 2.222-.135.144-1.577-.84-1.973-1.348-.524-.67-1.871-4.774-1.871-5.7 0-.728.282-1.34.865-1.87.628-.573 1.924-.878 1.924-.454zm53.165.24c.702.497 1.148 1.287 1.148 2.035 0 .964-1.333 5.06-1.87 5.748-.396.506-1.841 1.494-1.972 1.348-.029-.033.12-1.177.33-2.543.21-1.365.433-3.517.496-4.782l.115-2.299.671.101c.37.055.856.232 1.082.392zm-30.076 7.803a7.013 7.013 0 00-1.43 1.029c-.645.63-1.476 2.02-1.476 2.47 0 .145-.264.31-.666.415-.81.213-1.925 1.161-2.245 1.91-.139.322-.231 1.038-.224 1.73.037 3.55 2.768 6.865 6.438 7.819 1.182.306 3.474.295 4.584-.023 3.31-.95 5.768-3.72 6.259-7.057.315-2.145-.243-3.332-1.95-4.141-.917-.436-1.045-.56-1.37-1.327-.437-1.026-1.015-1.4-1.77-1.143-.794.27-.94.86-.518 2.083.532 1.544.26 2.648-.897 3.64-1.553 1.33-4.08.86-5.017-.933-.383-.733-.431-2.007-.106-2.766.241-.562 1.453-1.717 1.802-1.717.366 0 .93-.716.93-1.179 0-.54-.667-1.227-1.181-1.216-.207.004-.73.187-1.163.406zm-2.697 7.099c.409 1.124 1.563 2.304 2.866 2.93.933.449 1.26.522 2.328.524 1.722.002 2.748-.375 3.933-1.446.656-.593 1.092-1.165 1.402-1.838.443-.964.454-.974.78-.686.282.248.316.417.23 1.13-.258 2.154-1.541 3.938-3.513 4.885-1.013.486-1.21.524-2.736.524-1.486 0-1.737-.045-2.625-.47-1.259-.604-2.449-1.768-3-2.936-.663-1.405-.696-3.402-.056-3.402.057 0 .233.353.39.785zm-19.9 21.368c-.503.244-.885 1.289-1.23 3.361-.527 3.178-.244 4.78 1.074 6.066 1.366 1.335.19 1.26 19.7 1.26 9.452 0 17.305-.046 17.45-.1.147-.055.38-.315.52-.577.208-.393.217-.561.053-.948-.11-.259-.332-.54-.494-.624-.184-.096-6.76-.155-17.387-.155-18.826 0-17.814.054-18.444-.986-.262-.432-.289-.712-.198-2.04.058-.847.255-2.144.437-2.884.349-1.418.329-1.745-.131-2.14-.435-.372-.899-.452-1.35-.233z" fill="#04A061"/></symbol><symbol id="svg-icon-about-6" viewBox="0 0 97 97"><path fill-rule="evenodd" clip-rule="evenodd" d="M47.266 16.062c-.471 1.83-1.259 3.183-4.792 8.237-3.029 4.33-4.246 6.274-5.455 8.713-1.6 3.227-2.286 5.66-2.334 8.284l-.027 1.474-1.538.565c-8.6 3.158-16.67 8.974-21.201 15.278l-.913 1.27-.003 1.36L11 62.606l.738 1.093c1.123 1.664 2.783 3.574 4.513 5.19 1.745 1.632 4.4 3.8 4.66 3.805.167.003 1.225-1.36 1.219-1.572-.002-.06-.282-.304-.623-.542-2.268-1.584-5.7-4.884-7.32-7.04-.976-1.298-.988-1.324-.989-2.24 0-.898.024-.958.829-2.027 3.17-4.21 8.332-8.413 13.968-11.372 3.105-1.63 6.863-3.148 7.05-2.847.065.106-.471.77-1.394 1.724-2.896 2.996-4.683 6.317-5.537 10.29-.471 2.19-.47 6.267.003 8.447.911 4.198 2.7 7.413 5.893 10.587 1.033 1.026 1.81 1.867 1.726 1.867-.336 0-4.56-1.7-6.2-2.497-.964-.468-1.805-.818-1.87-.777-.14.086-.846 1.45-.846 1.633 0 .189 3.778 1.976 5.786 2.738 3.267 1.238 7.134 2.22 10.767 2.733 2.127.3 8.542.257 10.767-.073 9.744-1.445 18.734-5.72 26.21-12.463 1.67-1.506 3.67-3.756 4.78-5.377l.87-1.27-.003-1.366-.003-1.366-.912-1.27c-4.533-6.305-12.602-12.12-21.204-15.278l-1.541-.566-.016-1.328c-.057-4.69-1.978-8.893-7.904-17.289-3.19-4.52-4.223-6.304-4.683-8.09L49.46 15H47.54l-.274 1.062zm2.132 4.322c.454.784 1.935 3.007 3.292 4.94 4.067 5.797 5.6 8.427 6.63 11.373 1.828 5.238.853 10.085-2.71 13.456-2.343 2.216-4.927 3.25-8.11 3.245-4.726-.009-8.883-2.716-10.79-7.028-.704-1.59-.969-3.134-.886-5.158.181-4.44 1.722-7.677 7.703-16.181 1.132-1.61 2.473-3.635 2.98-4.499.506-.863.953-1.57.993-1.57.04-.002.445.639.898 1.422zm13.824 24.923c7.495 2.638 15.592 8.372 19.796 14.019.755 1.014.785 1.089.783 1.977-.001.86-.044.98-.639 1.772-3.83 5.1-9.809 9.713-16.644 12.842-1.73.793-4.961 2.05-5.266 2.05-.077 0 .705-.84 1.738-1.866 3.195-3.177 4.992-6.407 5.89-10.587.435-2.03.477-6.12.082-8.087-.825-4.114-2.648-7.576-5.602-10.644-1.344-1.395-1.771-2.1-1.112-1.831.133.053.57.214.974.355zM36.26 48.223c.556 1.097 2.038 2.983 2.975 3.786 1.181 1.011 2.057 1.582 3.37 2.196.624.291 1.16.55 1.192.575.167.128-.794 1.254-1.336 1.566-1.253.72-2.353.682-3.7-.13-.462-.277-.892-.472-.956-.432-.065.04-.314.616-.554 1.28-2.14 5.916.44 12.357 6.023 15.038 1.904.914 2.785 1.099 5.226 1.099s3.322-.185 5.226-1.1c7.077-3.397 8.978-12.443 3.918-18.651l-.65-.8.673-.557c.883-.73 2.254-2.435 2.93-3.643l.538-.964.582.56c.826.796 2.306 2.726 3.014 3.93 2.75 4.676 3.237 10.827 1.26 15.942-3.163 8.188-11.615 13.18-20.128 11.887-7.875-1.196-14.04-6.982-15.688-14.724-.424-1.995-.464-5.303-.086-7.202.71-3.575 2.228-6.59 4.643-9.23.574-.627 1.07-1.14 1.104-1.14.034 0 .224.321.424.715zm19.545 6.384c2.421 2.626 3.245 6.398 2.127 9.733-.55 1.638-1.146 2.582-2.464 3.903-2.065 2.068-4.088 2.915-6.968 2.915s-4.903-.847-6.968-2.915c-1.324-1.326-1.904-2.248-2.496-3.967-.357-1.034-.403-1.377-.395-2.929.011-2.148.141-2.666.642-2.563.195.04.915.072 1.6.071 1.035-.002 1.385-.068 2.076-.39 1.082-.503 2.037-1.395 2.557-2.388.377-.72.452-.785.785-.691.202.057 1.225.1 2.272.095 2.15-.01 3.886-.358 5.42-1.086.484-.23.953-.424 1.044-.43.09-.007.436.282.768.642zM23.435 73.26l-.528.854.873.545c.48.3.888.525.907.5.094-.125.924-1.386 1.011-1.536.062-.107-.226-.37-.763-.696-.475-.288-.887-.523-.917-.522-.03 0-.292.385-.583.855z" fill="#04A061"/></symbol><symbol id="svg-icon-about-7" viewBox="0 0 97 97"><path fill-rule="evenodd" clip-rule="evenodd" d="M47.264 12.485c-4.187 4.912-9.045 7.907-15.514 9.567-2.624.673-4.89.995-8.386 1.193-2.583.146-2.864.19-3.117.485-.265.31-.276.895-.22 11.805.056 10.954.075 11.58.4 13.63 2.05 12.936 8.45 21.678 25.415 34.716C47.814 85.397 48.717 86 49.015 86c.681 0 8.556-6.211 12.905-10.18 3.563-3.25 8.1-8.305 8.1-9.025 0-.495-.594-1.101-1.078-1.101-.376 0-.703.306-2.198 2.054-1.867 2.182-5.462 5.829-7.621 7.73-2.832 2.493-9.821 8.042-10.13 8.042-.066 0-1.043-.71-2.17-1.576-16.108-12.389-22.296-20.861-24.323-33.3-.229-1.404-.273-3.118-.324-12.416l-.058-10.787 2.043-.099c5.426-.261 10.787-1.653 15.281-3.968 3.21-1.652 5.413-3.288 8.03-5.961l1.513-1.545.343.453c1.323 1.747 4.15 4.208 6.342 5.525 4.885 2.932 10.985 4.675 19.141 5.47l1.031.1.043 7.025c.04 6.657.058 7.042.335 7.35.403.45 1.224.44 1.541-.018.209-.3.239-1.326.239-8.043 0-7.104-.02-7.724-.269-8.025-.23-.282-.537-.35-2.186-.49-6.965-.593-12.353-1.93-16.85-4.18-3.49-1.746-5.995-3.787-8.175-6.663-.83-1.096-1.08-1.326-1.477-1.365-.435-.043-.596.09-1.779 1.478zm5.147 16.091c-2.666.725-4.52 2.765-4.98 5.478-.351 2.065.335 4.18 1.87 5.76 3.128 3.223 8.553 2.363 10.571-1.675.988-1.976.987-4.143 0-6.12-1.362-2.724-4.604-4.22-7.461-3.443zm3.49 2.39c2.056 1.042 3.026 3.28 2.386 5.505-.358 1.241-1.654 2.577-2.85 2.936-1.844.553-3.296.191-4.629-1.153-.695-.701-.924-1.062-1.131-1.783-.728-2.527.599-4.978 3.154-5.828.681-.227 2.326-.054 3.07.323zm-18.997 2.728c-.301.213-.341.378-.341 1.4 0 .965-.045 1.174-.269 1.25-.148.05-.641.259-1.096.462l-.828.37-.813-.777c-.898-.857-1.397-.98-1.905-.466-.539.544-.4 1.159.469 2.087.432.461.707.872.62.926-.086.053-.306.513-.49 1.022l-.334.925h-1.02c-1.254 0-1.701.259-1.701.987 0 .874.278 1.077 1.609 1.174l1.186.087.23.688c.126.379.325.835.442 1.015.196.303.154.385-.553 1.089-.587.584-.765.87-.763 1.232.003.562.112.75.579.999.481.256.884.093 1.719-.697l.712-.672 1.064.435 1.065.434.077 1.2c.06.952.138 1.245.374 1.42.361.266.614.276 1.055.041.507-.269.56-.426.564-1.626.002-1.079.013-1.11.424-1.21.232-.057.721-.248 1.087-.425l.665-.321.716.707c.89.88 1.35 1.017 1.912.57.656-.52.563-1.096-.33-2.06l-.745-.804.35-.758c.191-.416.382-.887.423-1.046.063-.242.227-.289 1.02-.289 1.329 0 1.84-.303 1.844-1.094.005-.772-.325-.992-1.613-1.076l-1.18-.078-.232-.697c-.128-.384-.326-.833-.44-.997-.187-.27-.133-.38.556-1.115.876-.936.988-1.496.408-2.046-.546-.518-.958-.42-1.858.44l-.813.776-.827-.37a20.8 20.8 0 00-1.097-.462c-.221-.076-.268-.282-.268-1.182 0-.883-.058-1.148-.307-1.4-.368-.371-.882-.397-1.347-.068zm1.927 4.96c.716.3 1.507 1.057 1.889 1.806.371.728.395 2.26.046 2.96-1.066 2.133-3.695 2.735-5.423 1.242-.976-.844-1.278-1.576-1.21-2.931.047-.951.128-1.233.516-1.79.907-1.303 2.778-1.88 4.182-1.288zm22.798 4.221c-2.705.978-3.872 3.922-2.57 6.49 1.767 3.492 7.066 3.109 8.285-.6.316-.96.24-2.746-.148-3.502-1.066-2.076-3.519-3.128-5.566-2.388zm2.55 2.198c1.065.55 1.558 1.932 1.11 3.115-.235.62-1.153 1.34-1.86 1.461-1.349.23-2.771-.984-2.771-2.364 0-1.89 1.867-3.064 3.52-2.212zm11.838 1.077c-.188.19-.33.623-.394 1.202a37.492 37.492 0 01-.243 1.746c-.197 1.167-.19 1.216.234 1.645.854.862 1.634.249 1.89-1.485.376-2.551.376-2.545.03-2.99-.39-.5-1.084-.555-1.517-.118zm-23.739 6.952c-.346.234-.522.818-.522 1.736 0 .765-.05.961-.268 1.028-.148.045-.622.247-1.054.448l-.784.366-.75-.77c-.646-.663-.822-.764-1.272-.724-.656.057-1.177.684-1.01 1.216.061.195.42.69.8 1.098l.687.743-.314.664c-.173.365-.36.856-.416 1.09-.1.417-.128.427-1.226.427-1.17 0-1.484.144-1.681.77-.098.311.143.924.443 1.126.093.063.663.115 1.265.117 1.068.002 1.099.013 1.199.428.056.234.243.725.416 1.09l.314.664-.688.743c-.378.409-.738.903-.8 1.099-.16.51.355 1.157.971 1.22.4.04.623-.084 1.29-.715l.806-.763.75.353c.412.194.879.387 1.036.428.24.064.286.23.286 1.03 0 1.342.3 1.858 1.084 1.863.763.004.981-.328 1.065-1.629l.077-1.192.69-.234c.38-.13.825-.33.988-.445.267-.189.375-.134 1.103.562.905.864 1.517 1.001 2.053.46.508-.513.387-1.018-.462-1.925l-.769-.82.366-.837c.202-.46.407-.958.457-1.107.076-.224.28-.271 1.17-.271.875 0 1.138-.059 1.387-.31.368-.372.394-.89.068-1.36-.21-.304-.375-.345-1.386-.345-.956 0-1.163-.045-1.239-.271-.05-.15-.255-.648-.457-1.108l-.366-.836.77-.82c.848-.908.97-1.412.461-1.925-.536-.542-1.148-.404-2.054.461-.59.564-.853.726-.977.6-.094-.094-.538-.297-.987-.45l-.816-.279-.077-1.15c-.043-.638-.17-1.265-.287-1.407-.215-.26-1.033-.344-1.34-.137zm-16.123.512c-1.414.273-2.741 1.313-3.331 2.61-.243.534-.324 1.023-.326 1.952-.002 1.086.054 1.343.45 2.065.506.922 1.16 1.562 2.123 2.078.897.48 2.796.492 3.794.023 3.466-1.63 3.527-6.7.101-8.332-.91-.433-1.896-.572-2.811-.396zm2.166 2.466c.983.615 1.362 1.895.884 2.986-.433.989-1.12 1.435-2.21 1.435-.94 0-1.438-.26-2.034-1.067-.468-.633-.441-2.011.052-2.71a2.444 2.444 0 013.308-.644zm35.28.507c-.17.192-.401.593-.513.892-.113.298-.4.941-.64 1.429-.238.488-.433 1.063-.433 1.279 0 .858 1.186 1.348 1.747.721.33-.369 1.627-3.26 1.628-3.63.001-.398-.688-1.04-1.116-1.04-.2 0-.503.157-.673.35zm-18.49 2.097c1.92 1.57 1.567 4.832-.64 5.911-.883.432-2.347.44-3.165.02-2.017-1.04-2.58-3.715-1.14-5.415.68-.8 1.293-1.139 2.281-1.256.966-.115 1.954.16 2.664.74z" fill="#04A061"/></symbol><symbol id="svg-icon-arrow-left" viewBox="0 0 22 36"><path d="M20 2L4 18l16 16" stroke-width="5"/></symbol><symbol id="svg-icon-arrow-right" viewBox="0 0 22 36"><path d="M2 2l16 16L2 34" stroke-width="5"/></symbol><symbol id="svg-icon-burger" viewBox="0 0 30 17"><rect width="30" height="3" rx="1.5" fill="#02A162"/><rect y="14" width="30" height="3" rx="1.5" fill="#02A162"/><rect x="10" y="7" width="20" height="3" rx="1.5" fill="#02A162"/></symbol><symbol id="svg-icon-close" viewBox="0 0 24 24"><rect x=".121" y="21.213" width="30" height="3" rx="1.5" transform="rotate(-45 .121 21.213)" fill="#02A162"/><rect x="2.121" y=".213" width="30" height="3" rx="1.5" transform="rotate(45 2.121 .213)" fill="#02A162"/></symbol><symbol id="svg-icon-download" viewBox="0 0 22 22"><path d="M20 13a1 1 0 00-1 1v4a1 1 0 01-1 1H4a1 1 0 01-1-1v-4a1 1 0 10-2 0v4a3 3 0 003 3h14a3 3 0 003-3v-4a1 1 0 00-1-1zm-9.71 1.71a1 1 0 00.33.21.94.94 0 00.76 0 1 1 0 00.33-.21l4-4a1.004 1.004 0 10-1.42-1.42L12 11.59V2a1 1 0 00-2 0v9.59l-2.29-2.3a1.004 1.004 0 10-1.42 1.42l4 4z" fill="#fff" stroke="#fff"/></symbol><symbol id="svg-icon-plus" viewBox="0 0 60 60"><path fill="#11B2A9" d="M15 27.75h30v4.5H15z"/><path transform="rotate(90 32.25 15)" fill="#11B2A9" d="M32.25 15h30v4.5h-30z"/><circle cx="30" cy="30" r="28" stroke="#11B2A9" stroke-width="4"/></symbol><symbol id="svg-icon-use-1" viewBox="0 0 161 145"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.45 9.408c-1.283.713-1.245.076-1.255 21.366-.008 19.657-.003 19.859.5 20.5.835 1.065 1.827 1.199 8.228 1.11l5.893-.08.721-.81.721-.809V25.17h23.728l.808-.724.807-.723V10.508l-.807-.723-.808-.723-18.972.01c-15.274.006-19.088.072-19.564.336zm84.722.377l-.808.723v13.215l.808.723.807.724h23.729v25.515l.721.81.721.81 6.14.069c5.489.063 6.231.023 7.002-.372 1.415-.725 1.479-1.055 1.483-7.59l.004-5.91-.841-.843c-.925-.927-1.722-1.065-2.832-.49-1.12.58-1.272 1.28-1.272 5.854v4.201h-6.181V34.698c0-13.589.001-13.57-1.353-14.188-.474-.216-3.784-.296-12.258-.296h-11.609v-6.195h31.401v2.001c0 1.882.043 2.045.723 2.726.948.95 2.386 1.004 3.404.127l.694-.598.08-3.746.08-3.745-.859-.861-.858-.86h-38.119l-.807.722zm-49.64 7.331v3.098H41.923c-8.474 0-11.784.08-12.257.296-1.355.618-1.353.6-1.353 14.188v12.526h-6.181V14.02h31.4v3.097zm86.633 8.932c-2.213 1.122-1.447 4.573 1.015 4.573 1.159 0 1.761-.333 2.226-1.234.549-1.066.457-1.887-.307-2.727-.832-.915-1.898-1.138-2.934-.612zM79.59 38.04c-1.19.504-1.58 1.418-1.58 3.712v2.144l-3.4.297c-13.906 1.219-26.787 6.664-36.16 15.288-2.437 2.243-5.592 5.766-6.776 7.566-1.474 2.243-1.921 3.528-1.921 5.524 0 3.197 2.084 6.433 7.62 11.83 1.613 1.572 3.838 3.537 4.946 4.368 9.076 6.805 20.275 10.966 32.415 12.043l3.276.291v2.173c0 2.047.042 2.219.717 2.976.593.666.895.804 1.756.804.86 0 1.163-.138 1.756-.804.676-.758.716-.927.716-2.994v-2.191l2.432-.168c5.562-.384 12.759-1.903 17.755-3.749 3.265-1.206 8.341-3.674 11.178-5.436 3.553-2.205 6.067-4.188 9.272-7.313 3.655-3.563 5.684-6.064 6.763-8.338.709-1.492.838-2.038.843-3.552.01-3.167-1.692-5.962-6.777-11.123-4.566-4.635-9.053-7.857-15.082-10.83a64.367 64.367 0 00-23.973-6.462l-2.41-.167v-2.19c0-2.042-.046-2.24-.68-2.938-.73-.803-1.842-1.118-2.686-.761zm-1.58 12.913c0 2.243.354 3.2 1.353 3.656 1.269.58 2.651.161 3.24-.979.22-.428.352-1.44.352-2.713v-2.03l1.786.166c.982.091 2.69.478 3.794.86 7.686 2.655 13.645 9.434 15.323 17.432.592 2.82.687 2.676-1.76 2.676-2.014 0-2.157.036-2.843.724-1.018 1.02-1.018 2.488 0 3.508.686.688.829.724 2.843.724 2.447 0 2.352-.144 1.76 2.676-1.658 7.903-7.48 14.588-15.133 17.379-1.148.418-2.828.81-3.894.906l-1.876.17v-2.004c0-2.288-.301-3.155-1.272-3.658-.862-.447-1.538-.447-2.4 0-.968.502-1.273 1.369-1.273 3.623v1.971l-.803-.001c-4.105-.007-10.046-2.89-13.784-6.689-3.526-3.584-5.955-8.445-6.581-13.173l-.159-1.2h2.153c2.049 0 2.187-.035 2.875-.724 1.017-1.02 1.017-2.488 0-3.508-.688-.69-.826-.724-2.875-.724h-2.153l.159-1.2c1.037-7.835 6.571-15.057 14.019-18.291 2.171-.943 4.443-1.521 6.099-1.553l1.05-.02v1.996zm-19.523 2.651c-3.194 3.805-5.626 8.947-6.417 13.567-.545 3.184-.221 2.85-2.764 2.85-2.146 0-2.27.03-2.963.724-1.018 1.02-1.018 2.488 0 3.508.693.694.817.724 2.962.724 2.544 0 2.22-.334 2.765 2.85.714 4.171 2.672 8.59 5.406 12.198l1.733 2.287-1.293-.51c-7.755-3.052-15.334-8.41-20.317-14.362-3.758-4.49-3.762-5.368-.048-9.84 4.561-5.492 11.509-10.571 18.764-13.716 1.53-.663 2.82-1.206 2.866-1.207.048-.001-.265.416-.694.927zm47.908 1.062c6.332 2.969 12.736 7.833 16.971 12.892 3.768 4.5 3.768 5.381.007 9.874-4.95 5.913-12.712 11.403-20.323 14.375l-1.293.505 1.732-2.287c2.734-3.608 4.693-8.026 5.407-12.198.545-3.184.221-2.85 2.764-2.85 2.146 0 2.27-.03 2.962-.724.567-.569.723-.947.723-1.754s-.156-1.186-.723-1.754c-.692-.694-.816-.724-2.962-.724-2.543 0-2.219.334-2.764-2.85-.714-4.171-2.673-8.59-5.407-12.198l-1.732-2.287 1.293.51c.711.279 2.216.941 3.345 1.47zM78.01 62.97c-2.825.79-5.067 2.636-6.32 5.203-2.905 5.95.642 12.808 7.263 14.042 2.824.527 6.125-.518 8.284-2.62 6.203-6.043 2.388-16.343-6.26-16.901-.998-.065-2.122.04-2.967.276zm3.83 4.933c1.608.486 2.773 1.668 3.244 3.293.341 1.176.34 1.437-.008 2.637a4.791 4.791 0 01-3.462 3.346c-3.931.992-7.28-3.28-5.438-6.933.45-.892 1.953-2.168 2.766-2.347a13.2 13.2 0 00.923-.232c.473-.159.793-.12 1.975.236zM18.764 92.92c-1.678.75-1.577-.615-1.577 21.415v19.917l.84.843.841.843h19.03c18.82 0 19.036-.006 19.675-.509 1.058-.834 1.192-1.834 1.107-8.247l-.079-5.906-.807-.723-.808-.723H33.258V94.315l-.721-.81-.721-.81-6.14-.06c-4.815-.047-6.307.014-6.912.285zm110.745-.174c-.302.058-.83.442-1.175.852l-.626.747v25.485h-23.729l-.807.724-.808.723v13.215l.808.723.807.723h38.119l.84-.843.841-.843v-19.917c0-18.013-.039-19.973-.403-20.495-.795-1.137-1.627-1.27-7.687-1.234-3.098.018-5.879.081-6.18.14zM28.313 110.278c0 9.166.079 12.676.295 13.152.614 1.35.673 1.356 13.291 1.356h11.633v6.195h-31.4V97.776h6.181v12.502zm110.521 4.101v16.602h-31.401v-6.195h23.538l.841-.842.841-.843V97.776h6.181v16.603z" fill="#02A162"/></symbol><symbol id="svg-icon-use-2" viewBox="0 0 178 160"><path fill-rule="evenodd" clip-rule="evenodd" d="M81.924 10.183c-19.117 1.812-36.121 8.97-49.75 20.942-5.375 4.721-17.098 15.96-18.072 17.327C12.555 50.622 12 52.547 12 55.74c0 2.623.06 2.878 1.213 5.133 1.127 2.202 1.728 2.86 8.343 9.137 8.875 8.422 12.58 11.712 16.327 14.5 3.966 2.95 10.375 6.74 11.398 6.74.883 0 2.307-1.194 2.307-1.933 0-1.258-.67-1.948-3.382-3.485-6.75-3.827-10.558-6.887-22-17.678-8.747-8.25-9.462-9.129-9.736-11.969-.17-1.773.306-3.54 1.369-5.071.908-1.31 14.937-14.635 18.785-17.842 4.672-3.896 9.739-7.185 15.53-10.083 3.186-1.594 8.724-3.94 9.3-3.94.099 0-.7.744-1.777 1.655-4.395 3.718-8.913 9.582-11.422 14.823-6.142 12.834-5.964 27.945.478 40.74 1.401 2.781 4.97 7.737 7.51 10.428l2.593 2.747L57 92.828l-1.836 3.186-1.905.152c-2.226.178-4.7 1.374-5.777 2.791-.777 1.023-18.298 31.291-18.88 32.618-.798 1.815-1.037 4.822-.564 7.086.574 2.745 1.405 4.343 3.295 6.335 2.821 2.975 5.917 4.197 10.078 3.979 4.051-.212 7.807-2.359 9.924-5.673 1.025-1.604 1.061-2.099.23-3.152-.881-1.117-2.502-1.109-3.413.018-1.652 2.042-3.249 3.367-4.62 3.833-5.568 1.892-11.18-2.049-11.143-7.825.007-.998.213-2.291.46-2.874.894-2.116 17.616-30.731 18.474-31.614.743-.764 1.11-.905 2.318-.891 1.245.015 2.076.389 6.289 2.831 2.67 1.547 5.092 3.086 5.384 3.42.292.333.531.989.531 1.457 0 .556-2.09 4.457-6.021 11.236-7.665 13.218-7.156 12.209-6.702 13.301.581 1.401 2.232 1.931 3.355 1.078.512-.388 12.786-21.391 13.508-23.112.855-2.041.325-5.373-1.097-6.895-.56-.6-.542-.656 1.152-3.507l1.72-2.896 2.812 1c5.46 1.946 8.203 2.352 15.845 2.347 5.528-.004 7.72-.137 11.528-.699 16.621-2.45 31.737-9.19 43.835-19.543 1.502-1.285 6.374-5.792 10.828-10.016 7.647-7.252 8.161-7.809 9.252-10.01 1.102-2.222 1.154-2.466 1.137-5.22-.035-5.29-.846-6.51-10.005-15.063-8.38-7.824-8.523-7.946-9.406-7.946-1.019 0-2.261 1.267-2.261 2.306 0 .908-.097.807 9.799 10.219 3.574 3.398 6.273 6.216 6.662 6.956.485.92.658 1.793.667 3.36.02 3.49-.338 3.97-9.186 12.328-11.162 10.543-13.874 12.802-19.933 16.6-4.178 2.618-14.397 7.527-15.671 7.527-.133 0 .747-.86 1.955-1.911 7.454-6.487 12.621-15.445 14.85-25.75.959-4.435.948-12.889-.023-17.416-2.168-10.111-7.55-19.421-14.737-25.493-1.227-1.037-2.192-1.927-2.143-1.979.175-.184 5.604 2.04 9.086 3.722 3.672 1.773 4.442 1.899 5.457.887.487-.485.627-1.806.285-2.693-.239-.621-5.523-3.275-10.143-5.095-6.779-2.669-13.878-4.495-21.367-5.496-4.344-.581-14.926-.832-18.96-.45zm15.32 4.982c8.396 1.754 15.529 5.547 21.366 11.362 12.528 12.48 15.639 30.98 7.909 47.026-5.527 11.474-16.516 19.874-29.363 22.448-3.643.73-11.649.73-15.287.001-12.832-2.57-23.703-10.801-29.232-22.13-3.226-6.61-4.23-11.012-4.21-18.47.01-4.08.145-5.738.651-8.018 2.844-12.805 10.694-22.96 22.214-28.736 2.665-1.337 8.471-3.197 11.239-3.602 1.251-.183 2.616-.392 3.033-.465 1.637-.285 9.372.102 11.68.584zm-12.741 5.63c-2.903.417-7.054 1.71-10.082 3.139-13.754 6.494-21.861 21.385-19.777 36.328 1.574 11.286 8.78 21.398 18.876 26.49 13.654 6.884 30.024 4.346 40.636-6.302 4.26-4.275 6.872-8.453 8.717-13.944 5.464-16.265-2.099-34.492-17.526-42.234-6.24-3.131-14.113-4.445-20.844-3.477zm9.556 4.64c12.395 1.864 21.976 10.623 25.214 23.049.982 3.77.991 10.244.02 14.14-1.362 5.465-3.859 9.963-7.839 14.117-3.911 4.082-8.562 6.807-14.308 8.383-2.56.702-3.517.806-7.486.815-4.998.011-7.234-.374-11.35-1.957-6.579-2.53-13-8.365-16.224-14.744-1.283-2.54-2.527-6.649-2.932-9.69-1.848-13.86 6.205-27.393 19.291-32.418 5.176-1.987 10.112-2.523 15.614-1.696zm43.736 1.17c-.888.942-.841 2.172.119 3.129.628.626.965.74 1.744.59 1.95-.375 2.632-2.332 1.283-3.677-.955-.952-2.271-.97-3.146-.042zM84.853 32.81c-.667.735-.65 2.552.029 3.141.292.253.906.549 1.365.658.77.182.834.311.834 1.693v1.495l-1.289.308c-.71.17-2.335.84-3.613 1.49l-2.323 1.18-1.07-1.099-1.069-1.1.587-.714c.795-.968.737-2.037-.158-2.93-1.348-1.344-2.102-1.044-5.23 2.074-3.126 3.118-3.426 3.87-2.078 5.214.895.893 1.967.95 2.938.158l.716-.585 1.108 1.071 1.107 1.071-1.15 2.161c-.633 1.189-1.315 2.876-1.517 3.75l-.367 1.588h-1.462c-1.405 0-1.471-.039-1.672-.983-.308-1.444-.972-2.042-2.266-2.042-1.989 0-2.275.647-2.275 5.143 0 4.495.286 5.143 2.275 5.143 1.243 0 1.927-.577 2.24-1.891.183-.768.313-.832 1.688-.832h1.49l.5 1.74c.274.956.954 2.573 1.512 3.593l1.013 1.855-1.112 1.075-1.112 1.075-.716-.585c-.971-.793-2.043-.735-2.938.158-1.348 1.344-1.048 2.096 2.079 5.214 3.127 3.119 3.881 3.418 5.229 2.074.895-.893.953-1.962.158-2.93l-.587-.714 1.079-1.11 1.078-1.108 1.86 1.01c1.022.556 2.644 1.235 3.603 1.509l1.744.498v1.642c0 1.604-.02 1.643-.863 1.643-1.134 0-1.867.852-1.867 2.17 0 1.924.681 2.217 5.157 2.217 4.508 0 5.157-.286 5.157-2.27 0-1.31-.731-2.117-1.92-2.117-.778 0-.81-.064-.81-1.643v-1.642l1.744-.498c.96-.274 2.581-.953 3.604-1.509l1.86-1.01 1.078 1.109 1.078 1.109-.587.714c-.791.964-.744 2.21.116 3.015 1.351 1.265 2.179.926 5.271-2.159 3.127-3.118 3.427-3.87 2.079-5.214-.895-.893-1.967-.95-2.937-.158l-.717.585-1.111-1.075-1.112-1.075 1.013-1.855c.557-1.02 1.238-2.637 1.512-3.594l.5-1.74h1.489c1.375 0 1.505.065 1.688.833.313 1.314.997 1.89 2.24 1.89 1.989 0 2.275-.647 2.275-5.142 0-4.496-.286-5.143-2.275-5.143-1.294 0-1.958.598-2.265 2.042-.201.942-.27.983-1.653.983h-1.443l-.523-1.891c-.288-1.04-.981-2.725-1.541-3.745l-1.017-1.855 1.112-1.075 1.111-1.075.717.585c.97.793 2.042.735 2.937-.158 1.348-1.343 1.048-2.096-2.079-5.214-3.126-3.118-3.881-3.418-5.229-2.074-.895.893-.953 1.962-.158 2.93l.587.714-1.078 1.11-1.078 1.108-1.86-1.01c-1.023-.556-2.644-1.235-3.604-1.509l-1.744-.498v-1.485c0-1.371.064-1.5.834-1.683 1.318-.313 1.896-.994 1.896-2.234 0-1.913-.505-2.118-5.21-2.118-3.587 0-4.163.07-4.602.553zm9.519 12.522c2.143 1.049 4.332 3.232 5.384 5.37.738 1.497.825 2.006.825 4.85 0 2.843-.087 3.352-.825 4.85-1.052 2.137-3.241 4.32-5.384 5.37-1.503.736-2.012.822-4.864.822-2.851 0-3.361-.086-4.864-.823-2.143-1.049-4.332-3.232-5.384-5.369-.738-1.5-.824-2.006-.824-4.85.001-3.773.508-5.163 2.752-7.556 2.666-2.842 4.683-3.66 8.775-3.556 2.269.057 3.014.208 4.409.892zm-28.45 49.376c.793.459 1.441.964 1.441 1.123 0 .158-.631 1.378-1.402 2.712-.974 1.683-1.536 2.373-1.84 2.257-1.037-.397-4.645-2.643-4.645-2.892 0-.245 1.496-2.962 2.636-4.788l.438-.7.966.725c.53.4 1.613 1.103 2.406 1.563z" fill="#02A162"/></symbol></svg>';
/* globals Raven */

/* eslint moduleName:0 */
"use strict";

(function () {
  var itsoftApp;
  var pageHeader = document.querySelector(".page-header");
  var slice = [].slice;
  /* Полифилы */

  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }

  (function (ELEMENT) {
    ELEMENT.matches = ELEMENT.matches || ELEMENT.mozMatchesSelector || ELEMENT.msMatchesSelector || ELEMENT.oMatchesSelector || ELEMENT.webkitMatchesSelector;

    ELEMENT.closest = ELEMENT.closest || function closest(selector) {
      if (!this) return null;
      if (this.matches(selector)) return this;

      if (!this.parentElement) {
        return null;
      } else return this.parentElement.closest(selector);
    };
  })(Element.prototype); // Hack for IE <= 8


  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (elt) {
      var len = this.length >>> 0;
      var from = Number(arguments[1]) || 0;
      from = from < 0 ? Math.ceil(from) : Math.floor(from);

      if (from < 0) {
        from += len;
      }

      for (; from < len; from++) {
        if (from in this && this[from] === elt) {
          return from;
        }
      }

      return -1;
    };
  }

  window.itsoftApp = itsoftApp = {
    createNS: function createNS(namespace) {
      var i, len, nsparts, parent, part;
      nsparts = namespace.split(".");
      parent = itsoftApp; // we want to be able to include or exclude the root namespace so we strip
      // it if it's in the namespace

      if (nsparts[0] === "itsoftApp") {
        nsparts = nsparts.slice(1);
      } // loop through the parts and create a nested namespace if necessary


      for (i = 0, len = nsparts.length; i < len; i++) {
        part = nsparts[i]; // check if the current parent already has the namespace declared
        // if it isn't, then create it

        if (typeof parent[part] === "undefined") {
          parent[part] = {};
        } // get a reference to the deepest element in the hierarchy so far


        parent = parent[part];
      }

      return parent;
    },
    isLocal: !!document.getElementById("js-server-local"),
    utils: {
      debouncer: function debouncer(func, timeout) {
        var timeoutID;

        if (timeout == null) {
          timeout = 200;
        }

        timeoutID = undefined;
        return function () {
          var args, scope;
          scope = this;
          args = arguments;
          clearTimeout(timeoutID);
          timeoutID = setTimeout(function () {
            func.apply(scope, Array.prototype.slice.call(args));
          }, timeout);
        };
      },
      // Stealed from
      // https://github.com/VodkaBears/Remodal
      getScrollbarWidth: function getScrollbarWidth() {
        return window.innerWidth - document.documentElement.clientWidth;
      },
      // TODO
      // REPAINT
      // Вызывает Recalculate Style
      // Проверить, из-за чего, и можно ли избавиться
      getScrTop: function getScrTop() {
        var $body, $document, $wrapper, scrTop;
        $document = itsoftApp.commonVars.$document;
        $body = itsoftApp.commonVars.$body;
        $wrapper = itsoftApp.commonVars.$wrapper;
        scrTop = Math.max($document.scrollTop, $body.scrollTop, $wrapper.scrollTop, 0); // console.log($document.scrollTop(), $body.scrollTop(), $wrapper.scrollTop())

        return scrTop;
      },
      getTime: function () {
        var res;

        if (window.performance && typeof window.performance.now === "function") {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }

            return parseFloat(window.performance.now().toFixed(precision));
          };
        } else {
          res = function res(precision) {
            if (precision == null) {
              precision = 1;
            }

            return parseFloat(new Date().getTime().toFixed(precision));
          };
        }

        return res;
      }(),
      newMeasureFunc: function newMeasureFunc(precision) {
        var res, t0;

        if (precision == null) {
          precision = 2;
        }

        t0 = itsoftApp.utils.getTime(precision);

        res = function res() {
          var t1, t2;
          t1 = itsoftApp.utils.getTime(precision);
          t2 = parseFloat((t1 - t0).toFixed(precision));
          t0 = t1;
          return t2;
        };

        return res;
      },
      getInitTimes: function getInitTimes() {
        var k, module, obj, ref, total;
        obj = {};
        total = 0;
        ref = itsoftApp.modules;

        for (k in ref) {
          module = ref[k];

          if (module.initialized && module.__mName__ !== undefined) {
            obj[module.__mName__] = module.__initTime__;
            total += module.__initTime__;
          }
        }

        obj.all = Math.round(total);
        return obj;
      },
      checkIsSafari: function checkIsSafari() {
        var UA = navigator.userAgent.toLowerCase();

        if (UA.indexOf('safari') != -1) {
          if (UA.indexOf('chrome') > -1) {
            return;
          } else {
            return true;
          }
        }
      },
      getViewportSize: function getViewportSize() {
        if (itsoftApp.utils.checkIsSafari()) {
          return document.documentElement.clientWidth;
        } else {
          return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        }
      },
      getHeaderHeight: function getHeaderHeight() {
        itsoftApp.commonVars.headerHeight = pageHeader.offsetHeight;
        return itsoftApp.commonVars.headerHeight;
      }
    },
    loadScript: function loadScript(url, callback, error) {
      var script;
      script = document.createElement("script"); // If "fallback" url passed as second argument

      var args = Array.prototype.slice.call(arguments);

      if (typeof callback === "string") {
        var fallbackUrl = callback;
        callback = error;
        var errorOri = args[3];

        error = function error() {
          DEBUG && console.log("%c[common] error while loading script: " + url + ". trying to load a fallback url: " + fallbackUrl, "color: red");
          itsoftApp.loadScript(fallbackUrl, callback, errorOri);

          if (!DEBUG && typeof Raven !== "undefined") {
            Raven.captureMessage("[common] error while loading script", {
              level: "warning",
              // one of 'info', 'warning', or 'error'
              extra: {
                "script": url,
                "fallback": fallbackUrl
              }
            });
          }
        };
      }

      var cb = function cb() {
        DEBUG && console.log("%c--[common] finished loading script: " + url, "color: #999");

        if (typeof callback === "function") {
          callback();
        }
      }; // IE


      if (script.readyState) {
        script.onreadystatechange = function () {
          if (script.readyState === "loaded" || script.readyState === "complete") {
            script.onreadystatechange = null;
            cb();
          }
        }; // Normal browsers

      } else {
        if (typeof error === "function") {
          script.onerror = error;
        }

        script.onload = cb;
      }

      script.src = url;
      document.getElementsByTagName("body")[0].appendChild(script);
      DEBUG && console.log("%c--[common] starting to load script: " + url, "color: #999");
    },
    loadStyle: function loadStyle(url) {
      var first, head, link;
      link = document.createElement("link");
      link.href = url;
      link.rel = "stylesheet";
      link.type = "text/css";
      head = document.getElementsByTagName("head")[0];
      first = head.firstChild; // Prepend styles in 'head' section

      head.insertBefore(link, first);
    },
    features: {
      // From Modernizr
      transitionEventEnd: function () {
        var el, t, transitions;
        el = document.createElement("fakeelement");
        transitions = {
          "transition": "transitionend",
          "OTransition": "oTransitionEnd",
          "MozTransition": "transitionend",
          "WebkitTransition": "webkitTransitionEnd"
        };

        for (t in transitions) {
          if (el.style[t] !== undefined) {
            el = null;
            return transitions[t];
          }
        }

        return false;
      }()
    },
    modules: {},
    initializedModules: [],
    createModule: function createModule() {
      var dep, dependencies, i, initFunc, j, len, mName, module, options, ref;
      mName = arguments[0], options = 3 <= arguments.length ? slice.call(arguments, 1, i = arguments.length - 1) : (i = 1, []), initFunc = arguments[i++];

      if (typeof initFunc !== "function") {
        throw "Missing an initialization function for module '" + mName + "'";
      } // Create a namespace


      module = itsoftApp.createNS("modules." + mName);
      module.__mName__ = mName;
      module.initialized = false; // Set dependencies

      if (options.length && options[0].length) {
        dependencies = [];
        ref = options[0];

        for (j = 0, len = ref.length; j < len; j++) {
          dep = ref[j];

          if (typeof dep === "string" && dependencies.indexOf(dep) < 0 && dep !== mName) {
            dependencies.push(dep);
          }
        }

        if (dependencies.length) {
          module.dependencies = dependencies;
        }
      } // Set initialization function and behavior


      module.init = function () {
        var depModule, e, initTime, initializedModules, l, len1, t1, t2;

        try {
          if (module.dependencies) {
            for (l = 0, len1 = dependencies.length; l < len1; l++) {
              dep = dependencies[l];
              depModule = itsoftApp.modules[dep];

              if (!depModule) {
                DEBUG && console.log("%c[modules] missed module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }

              if (depModule.initialized) {
                continue;
              }

              depModule.init();

              if (!depModule.initialized) {
                DEBUG && console.log("%c[modules] can't init module " + dep + " as a dependency for module " + mName + ". (it's ok only if module is not required for this page)", "color: #BB6565; font-style: italic");
                return false;
              }
            }
          }

          t1 = itsoftApp.utils.getTime();

          if (initFunc.call(module) !== false) {
            t2 = itsoftApp.utils.getTime();
            initTime = parseFloat((t2 - t1).toFixed(1));
            module.__initTime__ = initTime;
            DEBUG && console.log("[module " + mName + "] module initialized in " + initTime + " ms");
            module.initialized = true;
            initializedModules = itsoftApp.initializedModules || [];
            initializedModules.push(mName);
            itsoftApp.initializedModules = initializedModules;
          }
        } catch (error1) {
          e = error1;

          if (typeof Raven !== "undefined") {
            Raven.captureException(e);
          }

          itsoftApp.errorHandler(e, {
            moduleName: mName
          });
        }
      };

      return module;
    },
    errorHandler: function errorHandler(error, options) {
      var pre;
      pre = "[error]";

      if (options && options.moduleName) {
        pre += "[module " + options.moduleName + "]";
      }

      if (console && console.error) {
        console.error(pre + "\n" + error + "\nNavigator: " + window.navigator.userAgent);
      }
    }
  }; // Unit-tests for itsoftApp object

  if (DEBUG && typeof mocha !== "undefined" && typeof describe === "function") {
    mocha.setup("bdd");
    describe("itsoftApp object tests", function () {
      it("Should be an object", function () {
        expect(itsoftApp).to.be.an("object");
      });
      it("Should contain a loadScript function", function () {
        expect(itsoftApp.loadScript).to.be.a("function");
      });
      it("Should contain a loadStyle function", function () {
        expect(itsoftApp.loadStyle).to.be.a("function");
      });
      it("We can create a deep namespace scope with a string like 'ns1.ns2.ns3'", function () {
        itsoftApp.createNS("ns1.ns2.ns3");
        expect(itsoftApp.ns1).to.be.an("object");
        expect(itsoftApp.ns1.ns2).to.be.an("object");
        expect(itsoftApp.ns1.ns2.ns3).to.be.an("object");
        delete itsoftApp.ns1;
      });
      it("initializedModules must be defined from the start", function () {
        expect(itsoftApp.initializedModules).to.be.an("array");
      });
      describe(".modules", function () {
        it("Should be a function to create modules", function () {
          expect(itsoftApp.createModule).to.be.a("function");
        });
        it("We can simply create a single module", function () {
          var module, testFunc;

          testFunc = function testFunc() {
            console.log("test module init");
          };

          var mName = "testmodule" + Math.round(Math.random() * 100);
          module = itsoftApp.createModule(mName, testFunc);
          expect(module).to.be.equal(itsoftApp.modules[mName]);
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
        it("We can't create a module without initialization function", function () {
          var module;

          module = function module() {
            itsoftApp.createModule("testmodule");
          };

          expect(module).to["throw"];
        });
        it("Each module must have an init function", function () {
          var module;

          for (module in itsoftApp.modules) {
            expect(itsoftApp.modules[module].init).to.be.a("function");
          }
        });
        it("Should throw an exception if we try to initialize a module twice", function () {
          var mName, module, testFunc;
          mName = "testmodule" + Math.round(Math.random() * 100);

          testFunc = function testFunc() {
            return 1;
          };

          module = itsoftApp.createModule(mName, testFunc);
          module.init();
          expect(module.init).to["throw"];
          itsoftApp.initializedModules.splice(itsoftApp.initializedModules.indexOf(mName), 1);
          delete itsoftApp.modules[mName];
        });
      });
    });
  }

  var itsoftAppInitFunc = function itsoftAppInitFunc() {
    var init = function init() {
      itsoftApp.commonVars = {
        $document: document.documentElement,
        $body: document.body,
        $window: window,
        $wrapper: document.querySelector(".l-wrapper"),
        headerHeight: undefined
      };
      var benchmarkCloseBtn, benchmarkDiv, criticalInitTime, dColor, fTime, initTimes, m, module, moduleName, t, time, warningModules;

      if (DEBUG) {
        t = itsoftApp.utils.getTime();
      }

      itsoftApp.ajaxDisabled = false; //нужно для работы с аяксовыми переходами.

      itsoftApp.removeAllModules = function () {
        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];
          module.initialized = false;
        }

        itsoftApp.initializedModules = [];
        DEBUG && console.log("%c[common] all modules removed", "font-weight: bold;");
      };

      itsoftApp.initAllModules = function () {
        // Initialize itsoftApp modules
        itsoftApp.removeAllModules();

        for (m in itsoftApp.modules) {
          module = itsoftApp.modules[m];

          if (!module.initialized && typeof module.init === "function") {
            module.init();
          }
        }
      };

      itsoftApp.initAllModules();

      if (DEBUG) {
        fTime = Math.round(itsoftApp.utils.getTime() - t);
        dColor = fTime < 200 ? "green" : "red";
        console.log("%c[common] document ready event fired, " + itsoftApp.initializedModules.length + " modules initialized in " + fTime + " ms: " + function () {
          var i, len, ref, results;
          ref = itsoftApp.initializedModules;
          results = [];

          for (i = 0, len = ref.length; i < len; i++) {
            m = ref[i];
            results.push(" " + m + "(" + itsoftApp.modules[m].__initTime__ + "ms)");
          }

          return results;
        }(), "color: " + dColor);
      } // Add benchmark div


      benchmarkDiv = document.getElementById("benchmark");

      if (typeof itsoftApp.utils.getInitTimes === "function" && (DEBUG || window.location.hash === "#benchmark") && !benchmarkDiv) {
        benchmarkDiv = document.createElement("div");
        benchmarkDiv.className = "benchmark";
        benchmarkDiv.id = "benchmark";

        if (typeof itsoftApp.utils.getInitTimes === "function") {
          benchmarkDiv.innerHTML = "<small style=\"opacity: 0.7\">modules (ms):" + function () {
            var ref, results;
            ref = itsoftApp.utils.getInitTimes();
            results = [];

            for (m in ref) {
              t = ref[m];
              results.push(" " + m + ": " + t);
            }

            return results;
          }() + "</small>";
        } // Add close button


        benchmarkCloseBtn = document.createElement("a");

        benchmarkCloseBtn.onclick = function () {
          benchmarkDiv.parentNode.removeChild(benchmarkDiv);
        };

        benchmarkCloseBtn.innerHTML = "X";
        benchmarkCloseBtn.className = "benchmark__close";
        benchmarkDiv.appendChild(benchmarkCloseBtn);
        document.body.appendChild(benchmarkDiv);
      } // Check for "too complex" modules
      // WARNING иногда такие "ошибки" возникают спонтанно
      // (например, все модули инициализируются за 0-2 мс, а один "выстрелил" на 300 мс).
      // Если это станет мешать проектам, то можно данные предупреждения
      // из логгера убрать.


      if (!DEBUG && typeof Raven !== "undefined") {
        initTimes = itsoftApp.utils.getInitTimes();
        warningModules = [];
        criticalInitTime = 50;

        for (moduleName in initTimes) {
          time = initTimes[moduleName];

          if (moduleName === "all") {
            continue;
          }

          if (time > criticalInitTime) {
            warningModules.push(moduleName);
          }
        } //  CHANGED: Вот именно из-за того, что один из модулей может
        //  случайно инициализироваться за какое-то неадекватно большое для него время.
        //  if warningModules.length > 0


        if (warningModules.length > 1) {
          Raven.captureMessage("[common] detected some \"long\" (initTime > " + criticalInitTime + " ms) modules", {
            level: "warning",
            // one of 'info', 'warning', or 'error'
            extra: initTimes
          });
        }
      } // If unit tests library loaded, just load a file with tests


      if (typeof mocha !== "undefined") {
        mocha.setup("bdd");
        mocha.run();
      }
    };

    if ("addEventListener" in document) {
      init();
    }
  }; // Document ready event


  if ("addEventListener" in document) {
    document.addEventListener("DOMContentLoaded", itsoftAppInitFunc, false); // .. IE <= 8
  } else if ("attachEvent" in document) {
    document.attachEvent("onreadystatechange", function () {
      if (document.readyState === "complete") {
        itsoftAppInitFunc();
      }
    });
  }
})();
"use strict";

itsoftApp.createModule("accordion", function () {
  var module = this;

  var initAccordions = function initAccordions(accordion) {
    var accordionHeadElements = accordion.querySelectorAll(".js-accordion-head");

    var onAccordionClick = function onAccordionClick(evt) {
      var self = this;
      var selfPreventNone = self.hasAttribute("data-prevent-none");
      var selfOnce = self.hasAttribute("data-once");

      if (!selfPreventNone) {
        evt.preventDefault();
      }

      var activeItem;
      var activeHead;
      var currentItem;
      var currentHead; // стили находятся в файле assets/styles/page.styl

      var closeAccordion = function closeAccordion(el) {
        if (self.classList.contains("js-accordion-head--parent")) {
          // находим родителя активного элемента
          var parent = el;
          var accordionItem = el.closest(".js-accordion-item");
          var accordionContent = parent.querySelector(".js-accordion-content"); // добавляем класс для анимации отображения/скрытия

          parent.classList.add("js-accordion-parent--ready");
          var height = accordionContent.clientHeight + "px";
          accordionContent.style.height = height;

          var _onTransitionEnd2 = function onTransitionEnd() {
            // удаляем у активного элемента активный класс
            activeHead.classList.remove("js-accordion-head--active");
            accordionItem.classList.remove("js-accordion-item--active"); // у родителя тоже

            parent.classList.remove("js-accordion-parent--active");
            parent.classList.remove("js-accordion-parent--ready");
            accordionContent.removeEventListener("transitionend", _onTransitionEnd2);
          };

          accordionContent.addEventListener("transitionend", _onTransitionEnd2);
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              // добавляем для соседнего элемента с контентом нулевую высоту
              accordionContent.style.height = "0px";
            });
          });
        } else {
          var accordionContent = activeItem.querySelector(".js-accordion-content");
          var accordionItem = activeHead.closest(".js-accordion-item");
          var closedText = accordionItem.getAttribute("data-closed-text");
          activeHead.classList.add("js-accordion-head--ready");
          var height = accordionContent.clientHeight + "px";
          accordionContent.style.height = height;

          if (closedText) {
            activeHead.textContent = closedText;
          }

          var _onTransitionEnd2 = function _onTransitionEnd() {
            accordionItem.classList.remove("js-accordion-item--active");
            activeHead.classList.remove("js-accordion-head--ready");
            activeHead.classList.remove("js-accordion-head--active");
            accordionContent.removeEventListener("transitionend", _onTransitionEnd2);
          };

          accordionContent.addEventListener("transitionend", _onTransitionEnd2);
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              accordionContent.style.height = "0px";
            });
          });
        }
      };

      var openAccordion = function openAccordion(el) {
        if (self.classList.contains("js-accordion-head--parent")) {
          var parent = el;
          var accordionItem = el.closest(".js-accordion-item");
          var accordionContent = el.querySelector(".js-accordion-content");
          currentHead.classList.add("js-accordion-head--active");
          parent.classList.add("js-accordion-parent--active");
          accordionItem.classList.add("js-accordion-item--active");
          accordionContent.style.height = "auto";
          var height = accordionContent.clientHeight + "px";
          accordionContent.style.height = "0px";
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              accordionContent.style.height = height;
            });
          });
        } else {
          var accordionContent = currentItem.querySelector(".js-accordion-content");
          var openedText = currentItem.getAttribute("data-opened-text");
          var accordionItem = currentHead.closest(".js-accordion-item");
          currentHead.classList.add("js-accordion-head--active");

          if (openedText) {
            currentHead.textContent = openedText;
          }

          accordionItem.classList.add("js-accordion-item--active");
          accordionContent.style.height = "auto";
          var height = accordionContent.clientHeight + "px";
          accordionContent.style.height = "0px";
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              accordionContent.style.height = height;
            });
          });
        }
      }; // Если элемент, на котором произошло событие, имеет класс js-accordion-head--parent


      if (this.classList.contains("js-accordion-head--parent")) {
        // Если этот элемент был уже активен
        if (this.classList.contains("js-accordion-head--active")) {
          activeHead = self;
          activeItem = activeHead.closest(".js-accordion-item");
          var activeParent = activeHead.closest(".js-accordion-parent");
          closeAccordion(activeParent);
          accordion.classList.remove("js-accordion--active");
        } else {
          activeHead = accordion.querySelector(".js-accordion .js-accordion-head--active");

          if (activeHead) {
            activeItem = activeHead.closest(".js-accordion-item");
            var activeParent = activeHead.closest(".js-accordion-parent");
            closeAccordion(activeParent);
          }

          currentHead = self;
          currentItem = currentHead.closest(".js-accordion-item");
          var currentParent = currentHead.closest(".js-accordion-parent");
          openAccordion(currentParent);
          accordion.classList.add("js-accordion--active");
        }
      } else {
        // Если этот элемент был уже активен
        if (this.classList.contains("js-accordion-head--active")) {
          activeHead = self;
          activeItem = activeHead.closest(".js-accordion-item");
          closeAccordion();
          accordion.classList.remove("js-accordion--active");
        } else {
          activeHead = accordion.querySelector(".js-accordion .js-accordion-head--active");

          if (activeHead) {
            activeItem = activeHead.closest(".js-accordion-item");
            closeAccordion();
          }

          currentHead = self;
          currentItem = currentHead.closest(".js-accordion-item");
          openAccordion();
          accordion.classList.add("js-accordion--active");
        }
      }

      if (selfOnce) {
        self.removeEventListener("click", onAccordionClick);
      }
    };

    Array.prototype.forEach.call(accordionHeadElements, function (el) {
      el.addEventListener("click", onAccordionClick);
    });
  };

  var changeableElements = document.querySelectorAll("[data-change-vw]");

  if (changeableElements) {
    var currentViewport = itsoftApp.utils.getViewportSize();
    Array.prototype.forEach.call(changeableElements, function (changeableElement) {
      var direction = changeableElement.getAttribute("data-change-direction");

      if (!direction) {
        return;
      }

      if (direction === "from" && currentViewport >= +changeableElement.getAttribute("data-change-vw")) {
        var accordion = changeableElement.closest(".js-accordion");
        var head = changeableElement.querySelector(".js-accordion-head");
        changeableElement.classList.add("js-accordion-item--active");
        head.classList.add("js-accordion-head--active");
        accordion.classList.add("js-accordion--active");
      }
    });
  }

  module.callback = initAccordions;
});
"use strict";

itsoftApp.createModule("animateScroll", ["windowResize"], function () {
  var maxMobileWidth = 767;
  var module = this;
  var loaded = false;
  var pageHeader = document.querySelector("[data-fixed='true']");
  var viewportSize = itsoftApp.utils.getViewportSize();

  var getViewportSize = function getViewportSize() {
    viewportSize = itsoftApp.utils.getViewportSize();
  };

  var startScroll = function startScroll(target, padding, speed, speedAsDuration) {
    var defaultPadding = 0;

    if (pageHeader) {
      if (!itsoftApp.commonVars.headerHeight) {
        itsoftApp.utils.getHeaderHeight();
      }

      if (target.hasAttribute("data-offset")) {
        if (viewportSize <= maxMobileWidth) {
          defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
        } else {
          defaultPadding = itsoftApp.commonVars.headerHeight + itsoftApp.commonVars.headerHeight / 2;
        }
      } else if (target.hasAttribute("data-offset-mobile") && viewportSize <= maxMobileWidth) {
        defaultPadding = itsoftApp.commonVars.headerHeight * 1.5;
      } else {
        defaultPadding = itsoftApp.commonVars.headerHeight;
      }
    }

    var settings = {
      offset: defaultPadding
    };

    if (speed) {
      settings.speed = speed;
    }

    if (speedAsDuration) {
      settings.speedAsDuration = speedAsDuration;
    }

    var scroll = new SmoothScroll();

    if (!document.body.classList.contains("is-popup-opened")) {
      scroll.animateScroll(target, "auto", settings);
    } else {
      setTimeout(function () {
        scroll.animateScroll(target, "auto", settings);
      }, 800);
    }
  };

  var load = function load(target, padding, speed, speedAsDuration) {
    if (!loaded) {
      window.noZensmooth = true;
      itsoftApp.loadScript("assets/scripts/smoothScroll/smooth-scroll.min.js", function () {
        loaded = true;
        startScroll(target, padding, speed, speedAsDuration);
      });
    } else {
      startScroll(target, padding, speed, speedAsDuration);
    }
  };

  var initAnimateScroll = function initAnimateScroll(el, padding) {
    el.addEventListener("click", function (evt) {
      evt.preventDefault();
      var scrollId = evt.currentTarget.href;

      if (!scrollId || !(scrollId = scrollId.split('#')[1])) {
        return;
      }

      var target = document.querySelector('#' + scrollId);
      load(target);
    });
  };

  var links = document.querySelectorAll("a[href^='#']:not([href='#'])");
  Array.prototype.forEach.call(links, function (el) {
    initAnimateScroll(el);
  });
  module.callback = load;
  itsoftApp.modules.windowResize.addEvent(getViewportSize);
});
// itsoftApp.createModule("animations", function () {
//   var module = this;
//   var defaultOptions = {
//     draw: function (progress) {
//       elem.style.width = progress * 100 + '%';
//     },
//     timing: function(timeFraction) {
//       return timeFraction;
//     },
//     duration: 1000
//   }
//   var animate = function (options) {
//     var start = performance.now();
//     requestAnimationFrame(function animate(time) {
//       // timeFraction от 0 до 1
//       var timeFraction = (time - start) / options.duration;
//       if (timeFraction > 1) {
//         timeFraction = 1;
//       }
//       // текущее состояние анимации
//       var progress = options.timing(timeFraction)
//       options.draw(progress);
//       if (timeFraction < 1) {
//         requestAnimationFrame(animate);
//       }
//     });
//   };
//   module.callback = animate;
// });
"use strict";
"use strict";

/* globals Raven, $buoop, $buo, $buo_show */

/* eslint camelcase:0 */

/**
 * Ненавязчивая плашка, которая оповестит пользователя о том,
 * что его браузер устарел и нуждается в обновлении.
 * https://browser-update.org/
 *
 * NOTE: Для нормальных браузеров данная плашка, понятное дело, не отображается.
 * Но посмотреть, как она выглядит, можно, выполнив в консоли код:
 * $buo({}, true);
 */
itsoftApp.createModule("browserUpdate", ["pageLoad"], function () {
  // Локальные переменные
  var module = this;
  var isRavenOn = typeof window.Raven !== "undefined";
  /**
   * Запуск интервального таймера
   */

  var init = function init() {
    /**
     * Функция, которая будет вызываться с определённым интервалом
     * до тех пор, пока скрипты с сайта browser-update.org не загрузятся и не отработают.
     */
    var intervalFunc = function intervalFunc() {
      // Так как нет прямого метода, позволяющего определить, отработали или нет скрипты browser-update.org,
      // то определяем косвенно, по наличию некоторой глобальной переменной.
      if (typeof $buoop === "undefined") {
        return;
      } // Один раз определив момент, когда скрипты browser-update.org отработали,
      // отменяем интервальный таймер.


      clearInterval(interval); // Три разных косвенных способа проверить, была ли пользователю
      // показана плашка с предупреждением об устаревшем браузере:

      var barShown1 = !!document.getElementById("buorg");
      var barShown2 = $buoop.test;
      var barShown3 = typeof $buo_show !== "undefined"; // Необходимо, чтобы хотя бы один косвенный метод дал положительный результат,
      // тогда будем считать, что плашка, действительно, показана.

      var barShown = barShown1 || barShown2 || barShown3; // Если сам скрипт посчитал, что браузер не устаревший, хотя на самом деле
      // он не поддерживает некоторые функции, мы можем сами определить
      // дополнительные проверки, по результатам которых решим,
      // показывать или нет сообщение пользователю.

      var extaConditions = [];

      if (!barShown) {
        var fakeElem = document.createElement("div"); // Проверка, поддерживает ли браузер операции classList.add, classList.remove и т. п.
        // (проверку провалят браузеры на android 2.3.6 и аналогичные динозавры)

        if (!("classList" in fakeElem) || !("add" in fakeElem.classList)) {
          extaConditions.push("classList");
        } // Проверка, поддерживает ли браузер обработчик событий addEventListener
        // (проверку провалят старые IE)


        if (!("addEventListener" in document)) {
          extaConditions.push("addEventListener");
        } // Проверка, поддерживает ли браузер методы window.btoa и window.atob,
        // которые нужны для преобразований base64
        // (проверку провалят старые IE)


        if (itsoftApp.modules.base64 && itsoftApp.modules.base64.initialized === true) {
          extaConditions.push("base64");
        } // Если хотя бы одно из доп. условий сработало,
        // то показываем плашку с предложением обновить браузер.


        if (extaConditions.length > 0) {
          $buo({}, true); // Показать предупреждение (принудительно)

          barShown = true;
          DEBUG && console.log("[module browserUpdate] bar shown by additional conditions");
        }
      } // Создаём объект с параметрами, которые мы передадим в js-логгер


      var barShownMessage = barShown ? "shown" : "not shown";
      var extraContext = {};
      var key, value;

      for (key in $buoop) {
        value = $buoop[key];

        if ($buoop.hasOwnProperty(key) && typeof value !== "function") {
          extraContext[key] = value;
        }
      }

      if (extaConditions.length > 0) {
        extraContext["extraConditions"] = extaConditions.join(", ");
      } // Отправить сообщение в js-логгер
      // (только в том случае, если плашка показана)


      if (isRavenOn && barShown) {
        Raven.captureMessage("[module browserUpdate] old browser detected", {
          level: "info",
          // one of 'info', 'warning', or 'error'
          extra: extraContext
        });
      } // Передать в остальные модули, где будет происходить отправка
      // сообщений в логгер, параметр browserUpdateBar (показана плашка или нет).


      if (isRavenOn) {
        Raven.setExtraContext({
          browserUpdateBar: barShownMessage
        });
      }

      DEBUG && console.log("[module browserUpdate] object recieved. barShown: " + barShown + ". extraContext: ", extraContext);
      module.extraContext = extraContext;
      module.barShown = barShown;
    }; // Выполняем функцию с определённым интервалом,
    // так как загрузка скрипта //browser-update.org/update.min.js -
    // это не тот самый момент, когда отрабатывает сам скрипт.
    // Дело в том, что там дальше по цепочке грузится ещё один скрипт, вот почему
    // мы не можем чётко отследить момент, когда всё-таки у нас прошла проверка на устаревшие браузеры.
    // Функция будет выполняться до тех пор,
    // пока не появится объект $buoop - признак того, что проверка произведена.


    var interval = setInterval(intervalFunc, 100);
  };
  /**
   * Грузим первоначальный скрипт с сайта browser-update.org
   * (локальная версия - в качестве fallback'а),
   * после чего запускаем наш интервальный таймер,
   * ловим момент загрузки второго скрипта и т. д.
   */


  var load = function load() {
    itsoftApp.loadScript("//browser-update.org/update.min.js", "assets/scripts/browser-update.min.js", function () {
      DEBUG && console.log("[module browserUpdate] script loaded");
      init();
    });
  }; // Делегируем функцию в модуль pageLoad
  // (откладываем выполнение до полной загрузки страницы)


  DEBUG && console.log("%c--[module browserUpdate] delegating load to pageLoad module", "font-style: italic; color: #999");
  itsoftApp.modules.pageLoad.addEvent(load);
});
"use strict";

itsoftApp.createModule("checkMenuLink", function () {
  var menuLinkElements = document.querySelectorAll(".main-menu__link");
  Array.prototype.forEach.call(menuLinkElements, function (el) {
    var href = el.href;

    if (el.pathname + el.hash === location.pathname) {
      var menuItem = el.parentNode;
      menuItem.classList.add("main-menu__item--current");
      el.removeAttribute("href");
    }
  });
});
"use strict";

itsoftApp.createModule("cookie", function () {
  var module = this;
  var DEFAULT_DATE = 900; //24 ч || // 900 - 15 мин ???

  var setCookie = function setCookie(element, date) {
    var dAttrSave = element.getAttribute("data-save");

    if (!date) {
      date = DEFAULT_DATE;
    }

    document.cookie = dAttrSave + "=yes; path=/; max-age=" + date;
  };

  var getCookie = function getCookie(element) {
    var dAttrSave = element.getAttribute("data-save");
    var matches = document.cookie.match(new RegExp("(?:^|; )" + dAttrSave.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
  };

  var deleteCookie = function deleteCookie(element) {
    var dAttrSave = element.getAttribute("data-save");
    setCookie(dAttrSave, "", {
      "max-age": -1
    });
  };

  module.setCookie = setCookie;
  module.getCookie = getCookie;
  module.deleteCookie = deleteCookie;
});
"use strict";

/**
 * Кнопки в левом нижнем углу экрана
 * (только в режиме dev)
 *
 * NOTE: Код подключается с доп. командой DEBUG && -
 * это значит, что при минификации скриптов
 * данный модуль будет целиком вырезан, и можно не париться насчёт лишних килобайтов.
 */
DEBUG && itsoftApp.createModule("devBtns", function () {
  if (!document.querySelector(".js-toggle-styles") && !document.querySelector(".js-toggle-images")) {
    return false;
  }
  /**
   * Отображение без стилей
   * (полезно для проверки чистой разметки, заголовков, секций и т. п.)
   */


  (function () {
    var btn = document.querySelector(".js-toggle-styles");

    if (!btn) {
      return false;
    }

    var toggled = false;
    var links = document.querySelectorAll("link");

    var btnClick = function btnClick() {
      var link, i, media;

      if (!toggled) {
        for (i = links.length - 1; i >= 0; i--) {
          link = links[i];
          media = link.getAttribute("media");

          if (!media) {
            continue;
          }

          link.setAttribute("data-media", media);
          link.setAttribute("media", "none");
        }

        toggled = true;
      } else {
        for (i = links.length - 1; i >= 0; i--) {
          link = links[i];
          media = link.getAttribute("data-media");

          if (!media) {
            continue;
          }

          link.setAttribute("media", media);
          link.removeAttribute("data-media");
        }

        toggled = false;
      }
    };

    btn.addEventListener("click", btnClick, false);
  })();
  /**
   * Отображение без изображений,
   * но так, чтобы был виден текст атрибута alt.
   */


  (function () {
    var btn = document.querySelector(".js-toggle-images");

    if (!btn) {
      return false;
    }

    var toggled = false;
    var dAttrSrcOri = "data-src-ori";
    var attrSrc = "src";
    var i, img;

    var btnClick = function btnClick() {
      var images = document.querySelectorAll("img");

      for (i = images.length - 1; i >= 0; i--) {
        img = images[i];

        if (!toggled) {
          img.setAttribute(dAttrSrcOri, img.getAttribute(attrSrc));
          img.removeAttribute(attrSrc);
        } else {
          img.setAttribute(attrSrc, img.getAttribute(dAttrSrcOri));
          img.removeAttribute(dAttrSrcOri);
        }
      }

      toggled = !toggled;
    };

    btn.addEventListener("click", btnClick, false);
  })();
});
"use strict";

itsoftApp.createModule("disclaimer", ["windowResize"], function () {
  var pageFooter = document.querySelector(".page-footer");
  var disclaimer = document.querySelector(".js-disclaimer");
  var disclaimerButton = document.querySelector(".disclaimer__close-button");
  var disclaimerConfirm = document.querySelector(".disclaimer__confirm");
  var lwrapper = document.querySelector(".l-wrapper");

  var buttonMouseOver = function buttonMouseOver(evt) {
    if (!disclaimer.classList.contains("js-hover")) {
      disclaimer.classList.add("js-hover");
      disclaimerConfirm.addEventListener("mouseout", buttonMouseOut);
    }
  };

  var buttonMouseOut = function buttonMouseOut(evt) {
    setTimeout(function () {
      disclaimer.classList.remove("js-hover");
      disclaimerConfirm.removeEventListener("mouseout", buttonMouseOut);
    }, 2000);
  };

  var disclaimerClose = function disclaimerClose() {
    disclaimer.classList.add("js-static");
    disclaimer.classList.add("js-inactive");

    if (disclaimer.classList.contains("js-hover")) {
      disclaimer.classList.remove("js-hover");
    }

    disclaimerConfirm.style.display = "none";
    pageFooter.classList.add("js-update");
  };

  if (disclaimerButton) {
    disclaimerButton.addEventListener("mouseover", buttonMouseOver);
    disclaimerButton.addEventListener("click", function (evt) {
      evt.preventDefault();
      disclaimerClose();
    });
  }

  if (disclaimerConfirm) {
    disclaimerConfirm.addEventListener("click", function (evt) {
      evt.preventDefault();
      disclaimerClose();
    });
  }

  var footerCoordY;

  var defineCoordY = function defineCoordY() {
    footerCoordY = pageFooter.getBoundingClientRect().top + pageYOffset;
  };

  var checkElementCoords = function checkElementCoords() {
    var s_top = pageYOffset;

    if (s_top + document.documentElement.clientHeight > footerCoordY) {
      if (disclaimerButton) {
        disclaimerButton.classList.add("js-close-hide");
      }

      disclaimer.classList.add("js-inactive");
    } else if (!disclaimer.classList.contains("js-static")) {
      if (disclaimerButton) {
        disclaimerButton.classList.remove("js-close-hide");
      }

      disclaimer.classList.remove("js-inactive");
    } else {
      document.removeEventListener("scroll", onDocumentScroll);
      window.removeEventListener("resize", onDocumentResize);
    }
  };

  var onDocumentScroll = function onDocumentScroll() {
    checkElementCoords();
  };

  var onDocumentResize = function onDocumentResize() {
    defineCoordY();
    checkElementCoords();
  };

  if (disclaimer) {
    defineCoordY();
    checkElementCoords();
    document.addEventListener("scroll", onDocumentScroll);
    window.addEventListener("resize", onDocumentResize);
  }
});
"use strict";

itsoftApp.createModule("focus-visible", function () {
  itsoftApp.loadScript("assets/scripts/focus-visible/focus-visible.min.js");
});
"use strict";

itsoftApp.createModule("headerFixed", function () {
  itsoftApp.loadScript("assets/scripts/headroom/headroom.min.js", function () {
    var header = document.querySelector(".l-header");
    var pageWrapper = document.querySelector(".l-wrapper");
    var headerObj;
    var headerHeight;

    var setPagePadding = function setPagePadding() {
      pageWrapper.style.paddingTop = itsoftApp.commonVars.headerHeight;
    };

    var updateHeaderHeight = function updateHeaderHeight() {
      headerHeight = itsoftApp.utils.getHeaderHeight();
    };

    headerObj = new Headroom(header);
    itsoftApp.modules.windowResize.addEvent(updateHeaderHeight);
    headerObj.init();
  });
});
"use strict";

itsoftApp.createModule("lazyLoadingImages", function () {
  var module = this;

  var initLazy = function initLazy() {
    itsoftApp.loadScript("assets/scripts/lazysizes/lazysizes.min.js", function () {
      window.lazySizesConfig = window.lazySizesConfig || {};
    });
  };

  initLazy();
  module.callback = initLazy;
});
"use strict";

/* globals Raven */

/**
 * Отмена действия по умолчанию для ссылок с атрибутом href="#".
 * В нашей заготовки таковыми являются ссылки, для которых предполагается реальный href,
 * но который на вёрстке ещё не известен.
 * Если не отменить для таких ссылок действие по умолчанию,
 * то при клике страница перепрыгнет на самый верх, а в адресной строке появится #.
 *
 * NOTE: Также данный модуль отправляет сообщения в логгер, если подобные ссылки
 * найдены на продакт-сервере (там вместо # должны быть проставлены реальные адреса).
 */
itsoftApp.createModule("linksWithHash", function () {
  var links = document.querySelectorAll("a[href='#']");

  if (!links.length) {
    return false;
  }

  DEBUG && console.log("%c[module linksWithHash] " + links.length + " links with href='#' found. is it ok for this page?? maybe you need to replace '#' with normal link? check it.", "color: orange");
  var isLocal = itsoftApp.isLocal;
  /**
   * Простой обрабочик, который отменяет действие по умолчанию
   *
   * @param  {object} e Event
   */

  var linksWithHashHandler = function linksWithHashHandler(e) {
    e.preventDefault();
    DEBUG && console.log("[module linksWithHash] default action prevented for link");
  }; // Привязка функций к событиям


  for (var i = 0, len = links.length, link; i < len; i++) {
    link = links[i];
    link.addEventListener("click", linksWithHashHandler, false);
  } // Если на боевом сервере найдены ссылки с атрибутом href="#",
  // то отправляем в логгер сообщение об ошибке,
  // так как там уже должны быть настоящие ссылки вместо заглушек.


  if (typeof Raven !== "undefined" && !isLocal) {
    var extra = {}; // Формируем объект, в котором перечислены все найденные ссылки,
    // причём с указанием их html-кода
    // (для того, чтобы можно было определить, какие именно ссылки найдены, точно ли это ошибка или нет)

    Array.prototype.forEach.call(links, function (link, index) {
      var html = link.outerHTML;
      extra["link" + (index + 1)] = html;
    });
    Raven.captureMessage("[module linksWithHash] links with href='#' found", {
      level: "warning",
      // one of 'info', 'warning', or 'error'
      extra: extra
    });
  }
});
"use strict";

/**
 * Мобильное меню
 *
 * NOTE: Модуль можно удалить, если на сайте предусмотрено
 * принципиально иное меню для мобильных устройств.
 */
itsoftApp.createModule("mobMenu", ["windowScroll"], function () {
  var parentClass = "js-mobmenu";
  var parent = document.querySelector("." + parentClass);

  if (!parent) {
    return false;
  } // Локальные переменные


  var toggleBtns = document.querySelector(".js-mobmenu-toggle");
  var openedClass = "is-opened";
  var activeClass = "is-active";
  var opened = false;
  var $body = itsoftApp.commonVars.$body;
  var expandedBlocks = document.querySelector(".js-mobmenu-expand");
  var fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
  var getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
  var mainMenuLinks = document.querySelectorAll(".js-link");

  var openMenu = function openMenu() {
    if (opened) {
      return;
    }

    opened = true;

    if (fixedPageElems) {
      var scrollbarWidth = getScrollbarWidth();
      DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style.paddingRight = scrollbarWidth + "px";
      });
    }

    toggleBtns.classList.add(activeClass);
    parent.classList.add(openedClass);
    document.documentElement.style.overflow = 'hidden'; // NOTE: Отменил прокрутку

    DEBUG && console.log("[module mobMenu] menu opened");
  };

  var closeMenu = function closeMenu() {
    if (!opened) {
      return;
    }

    opened = false;

    if (fixedPageElems) {
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style.paddingRight = "0";
      });
    }

    document.documentElement.style.overflow = 'visible'; // NOTE: Вернул прокрутку

    toggleBtns.classList.remove(activeClass);
    parent.classList.remove(openedClass);
    DEBUG && console.log("[module mobMenu] menu closed");
  };

  var toggleBtnClick = function toggleBtnClick(evt) {
    evt.preventDefault();

    if (opened) {
      closeMenu();
    } else {
      openMenu();
    }
  };
  /**
   * Обработчик события пролистывания страницы.
   * Мы будем скрывать меню, если пользователь начал листать страницу вниз.
   *
   * @param  {number} y Текущее значение прокрутки страницы
   */


  var scrollController = function scrollController(y) {
    if (!opened) {
      return;
    } // Значение уже придёт нам из модуля itsoftApp.modules.windowScroll,
    // но на всякий случай пропишем fallback.


    y = typeof y === "number" ? y : document.body.scrollTop || document.documentElement.scrollTop;
    var menuHeight = parent.offsetHeight + expandedBlocks.offsetHeight;

    if (y + menuHeight > menuHeight + menuHeight / 3) {
      closeMenu();
    }
  };
  /**
   * Как и в случае со всплывашками на сайте,
   * для меню, если мы видим оставшуюся часть страницы, и кликаем по затемнённой области,
   * то пользователь интуитивно ожидает, что меню закроется.
   * Данный обработчик как раз для этого.
   *
   * @param  {object} e Event
   */


  var bodyClick = function bodyClick(e) {
    if (!opened) {
      return;
    }

    var target = e.target;
    var hasParent = target.closest("." + parentClass); // Закрываем меню, только если клик произошёл
    // по элементу вне пределов родительского блока
    // (по сути - клик по любой точке экрана, кроме меню).

    if (!hasParent) {
      closeMenu(); // Отмена действия по умолчанию
      // (например, чтобы не произошёл переход по ссылке, если
      // мы кликнули по элементу <a>).

      return false;
    }
  }; // Привязка событий и функций-обработчиков


  toggleBtns.addEventListener("click", toggleBtnClick);
  $body.addEventListener("click", bodyClick); // NOTE: Выловили нелепый баг, на айпадике.
  // Без строчки ниже не срабатывало событие click у верхнего элемента body.
  // Говно, дерьмо, жопа :D

  itsoftApp.commonVars.$wrapper.addEventListener("click", function () {});
  Array.prototype.forEach.call(mainMenuLinks, function (el) {
    el.addEventListener("click", function () {
      // if (currentOpenedPopup) {
      //     currentOpenedPopup.dispatchEvent(closeEvent);
      // }
      closeMenu();
    });
  }); // Делегируем функцию в модуль windowScroll
  // (единая точка входа для события "scroll").

  DEBUG && console.log("%c--[module mobMenu] delegating scrollController to windowScroll module", "font-style: italic; color: #999");
  itsoftApp.modules.windowScroll.addEvent(scrollController);
});
"use strict";

itsoftApp.createModule("mouseParallax", function () {
  var mouseParallax = document.querySelectorAll('.mouse-parallax');

  if (mouseParallax) {
    var _loop = function _loop(index) {
      var mouseParallaxItem = mouseParallax[index];
      window.addEventListener('mousemove', function (e) {
        var x = e.clientX / window.innerWidth;
        var y = e.clientY / window.innerHeight;
        mouseParallaxItem.style.transform = 'translate(-' + x * 15 + 'px, -' + y * 15 + 'px)';
      });
    };

    for (var index = 0; index < mouseParallax.length; index++) {
      _loop(index);
    }
  }

  var mouseParallaxRev = document.querySelectorAll('.mouse-parallax-rev');

  if (mouseParallaxRev) {
    var _loop2 = function _loop2(_index) {
      var mouseParallaxRevItem = mouseParallaxRev[_index];
      window.addEventListener('mousemove', function (e) {
        var x = e.clientX / window.innerWidth;
        var y = e.clientY / window.innerHeight;
        mouseParallaxRevItem.style.transform = 'translate(' + x * 15 + 'px, ' + y * 15 + 'px)';
      });
    };

    for (var _index = 0; _index < mouseParallaxRev.length; _index++) {
      _loop2(_index);
    }
  }
});
"use strict";

/**
 * Общая точка входа
 * для события полной загрузки страницы
 * (включая загрузку изображений, метрик и прочего).
 *
 * NOTE: Не путать с событием DOMContentLoaded
 * (оно же - $(document).ready(function() {...}) - в терминах jQuery).
 */
itsoftApp.createModule("pageLoad", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var singleFunctionFired = false;
  var timeoutInit = 120;
  var timeoutDelta = 80;
  var $window = itsoftApp.commonVars.$window;
  var flag = false;
  var body = document.body;
  /**
   * Функция, которая сработает лишь один раз,
   * и будет означать полную загрузку страницы.
   */

  var singleLoadFunction = function singleLoadFunction() {
    var readyState = document.readyState;
    var func, timeoutCurrent;

    if (readyState !== "complete" || singleFunctionFired || !events.length) {
      return false;
    }

    DEBUG && console.log("%c[module pageLoad] window load event fired, count of functions to init: " + events.length + ", timeout for first func: " + timeoutInit + ", timeout delta for other: " + timeoutDelta, "color: purple");

    while (events.length > 0) {
      // Взять первый элемент массива,
      // и передать его в переменную.
      func = events.shift(); // Будем запускать наши отложенные функции
      // через определённые промежутки времени, друг за другом с некоторым промежутком.
      // Мы уже знаем, что это функции,
      // поэтому доп. проверка не требуется.

      timeoutCurrent = timeoutCurrent ? timeoutCurrent + timeoutDelta : timeoutInit;
      setTimeout(func, timeoutCurrent);
    }

    singleFunctionFired = true;

    if (!flag) {
      $window.removeEventListener("load", singleLoadFunction);
      flag = true;
      body.classList.add("js-loaded");
    }
  }; // Привязка собитий и функции-обработчика


  if (document.readyState === "complete") {
    singleLoadFunction();
  } else {
    $window.addEventListener("load", singleLoadFunction);
  }
  /**
   * Добавление переданной функции в очередь на выполнение,
   * либо немедленное исполнение функции, если страница уже полностью загружена.
   *
   * @param {function} func
   */


  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    } // Если страница ещё не загружена полность, то добавляем в очередь


    if (!singleFunctionFired) {
      events.push(func);
      DEBUG && console.log("[module pageLoad] function added, count of functions to init now: " + events.length); // Если уже загружена, то просто вызываем переданную функцию
    } else {
      DEBUG && console.log("[module pageLoad] firing function immediately, because window load event already fired");
      func();
    }
  }; // Доступ к фукциям
  // текущего модуля


  module.addEvent = addEvent;
});
// itsoftApp.createModule("picturefill", ["lazyLoadingImages"], function () {
//     itsoftApp.loadScript("assets/scripts/picturefill/picturefill.min.js");
// })
"use strict";
"use strict";

/**
 * Всплывашки на сайте
 *
 * NOTE: Механизм, позволяющий отменить скролл для страницы, при открытой всплывашке,
 * достаточно хитрый, поэтому лучше изучить данный модуль, чтобы досконально понимать, как он работает
 */
itsoftApp.createModule("popups", function () {
  var BREAKPOINT = {
    mobile: 320,
    tablet: 768,
    desktop: 1280
  };
  var popupClass = "popup";
  var popups = document.querySelectorAll("." + popupClass);

  if (!popups.length) {
    return false;
  } // Локальные переменные


  var $body = document.body;
  var $document = document.documentElement;
  var $window = window;
  var $wrapper = document.querySelector(".l-wrapper");
  var activePopups = document.querySelectorAll("[data-bg-opened='true']");
  var openedClass = "is-opened";
  var dAttrSelector = "data-popup-selector";
  var dAttrBgClose = "data-bg-close";
  var hiddenClass = "g-hidden";
  var evNameOpen = "popups:open";
  var evNameClose = "popups:close";
  var wrapperAbsClass = "is-abs";
  var wrapperOverflow = "is-over";
  var popupOpenedClass = "is-popup-opened";
  var dAttrUrl = "data-url";
  var dAttrAutohide = "data-autohide";
  var dAttrHide = "data-hide";
  var dAttrClose = "data-close-popup";
  var popupBox = document.querySelector("#popup-box");
  var openPopupBtns = document.querySelectorAll(".js-open-popup");
  var closePopupBtns = document.querySelectorAll(".js-close-popup");
  var fixedPageElems = document.querySelectorAll(".js-page-fixed-elem");
  var hasFixedElems = fixedPageElems.length > 0;
  var hideDelayDefault = 3500;
  var staticBackUrl = window.location.pathname;
  var historyPushed = false;
  var autohidePopups = [].filter.call(popups, function (el) {
    return el.matches("[" + dAttrAutohide + "='true']");
  });
  var transitionEventEnd = itsoftApp.features.transitionEventEnd;
  var activeButton;
  /* ??? */

  var disabledButtons = document.querySelectorAll(".js-disabled");
  var confirmation = document.querySelector(".js-confirmation");
  var save = document.querySelector(".js-save");
  var slider = {};
  window.currentOpenedPopup = undefined;
  var currentSlide; // Перемещаем все всплывашки в конец <body>.
  // Это нужно для того, чтобы при открытии всплывашки,
  // событие "scroll" всплывало до <body> и <html>,
  // но НЕ всплывало до <div class="l-wrapper">.
  // Это важно, так как при открытии всплывашки прокрутка
  // убирается у <body> и появляется у <div class="l-wrapper">.
  // Тем самым, мы "отменяем скролл".
  //
  // NOTE: На самом деле, отменить стандартный скролл браузера нельзя
  // (иначе не было бы всей этой истории).
  // Можно отменить, например, всплытие события "click" или действие по умолчанию для него.
  // Но ряд событий отменить или прервать всплытие нельзя.
  // popups.forEach(function (el) {
  //     var self = el;
  //     var idSelf = self.id;
  //     if (!popupBox.querySelector("#" + idSelf)) {
  //         popupBox.appendChild(self.classList.remove(hiddenClass));
  //     }
  // })
  // Вспомогательные функции

  var getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;
  var getScrTop = itsoftApp.utils.getScrTop;

  var getOpenedPopups = function getOpenedPopups() {
    return [].filter.call(popups, function (el) {
      return el.classList.contains(openedClass);
    });
  };
  /**
   * Изменение адресной строки браузера при открытии всплывашки
   * (по необходимости).
   * Доп. инфа:
   * http://stackoverflow.com/questions/824349/modify-the-url-without-reloading-the-page
   *
   * @param  {string} url     Новый адрес
   * @param  {string} popupID Необходимо для отработки случая, когда мы перешли на страницу по прямому адресу
   */


  var changePageUrl = function changePageUrl(url, popupID) {
    // Если браузер не поддерживает работу с историей,
    // то прерываем выполнение функции.
    if (!window.history || typeof window.history.pushState !== "function" || typeof url !== "string") {
      DEBUG && console.log("%c[module popups] !window.history || typeof window.history.pushState != function || typeof url != string", "color: red");
      return;
    } // Переход "вперёд" по истории браузера ...


    if (url !== "back") {
      DEBUG && console.log("%c[module popups] trying to change page url to: " + url, "font-style: italic");
      window.history.pushState(false, false, url);
      historyPushed = true; // ... переход "назад"
    } else {
      // Случай, когда мы до этого открыли всплывашку и перешли "вперёд"
      if (historyPushed) {
        DEBUG && console.log("%c[module popups] trying to go back in history", "font-style: italic");
        window.history.back(); // Случай, когда до этого не было перехода "вперёд"
        // (например, пользователь перешёл по прямой ссылке).
      } else if (typeof popupID === "string") {
        var urlToChange = staticBackUrl;
        urlToChange = staticBackUrl.substring(0, staticBackUrl.length - popupID.length - 1);
        DEBUG && console.log("%c[module popups] replacing page url to " + urlToChange, "font-style: italic; color: orange");
        window.history.replaceState(false, false, urlToChange);
      }
    }
  };
  /**
   * Все действия, связанные с открытием всплывашки
   */


  var popupOpen = function popupOpen() {
    var self = this;

    if (self.classList.contains(openedClass)) {
      return;
    } // Если до этого уже были открыты всплывашки,
    // то вычисляем наибольший z-index, и присваиваем его
    // новой открывающейся всплывашке.
    // Иначе возможны ситуации, когда всплывашка открылась, но из-за расположения по вёрстке
    // оказалась ниже (за счет одинакового z-index), и в итоге её не видно.


    var openedPopups = getOpenedPopups();

    if (openedPopups.length > 0) {
      var maxZI = 0;
      Array.prototype.forEach.call(openedPopups, function (el) {
        var popup = el;

        if (popup.getAttribute("data-ignore") === "true") {
          return;
        }

        var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

        if (isNaN(zi)) {
          zi = 0;
        }

        maxZI = Math.max(maxZI, zi);
      });

      if (maxZI > 0) {
        self.style.zIndex = maxZI + 1;
        DEBUG && console.log("%c--[module popups] added z-index " + (maxZI + 1) + ", because there was another opened popups", "font-style: italic; color: #999");
      }
    } // Вычисляем текущую величину прокрутки страницы
    // (делаем это до того, как будут произведены какие-либо дальнейшие действия).


    var scrTop = getScrTop();
    DEBUG && console.log("[module popups] scrTop: " + scrTop); // Если есть fixed элементы на странице,
    // то задаём им padding-right, равный ширине полосы прокрутки.
    // Без этого такие элементы будут дёргаться,
    // так как в процессе открытия всплывашки слегка меняются общие стили страницы.

    if (hasFixedElems) {
      var scrollbarWidth = getScrollbarWidth();
      DEBUG && console.log("[module popups] scrollbarWidth: " + scrollbarWidth);
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style.paddingRight = scrollbarWidth + "px";
      });
    } // NOTE: Это из-за плашки browser-update,
    // которая задаёт <html> ненулевой margin-top,
    // (в случае, если плашка об устаревшем браузере показана)
    // из-за которого страница "прыгает".


    var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
    var mtExists = !isNaN(mt) && mt !== 0;

    if (mtExists) {
      scrTop -= mt;
    } // Основная магия происходит здесь.
    // Элементу .l-wrapper задаётся класс, который одновременно
    // убирает полосу прокрутки у <body> (так как .l-wrapper теперь position: absolute),
    // и добавляет полосу прокрутки у самого .l-wrapper (за счёт overflow: auto).
    // После этого остаётся прокрутить элемент .l-wrapper до того же значения,
    // которое было до этого у <body> (мы посчитали эту величину ранее).
    // Происходит это достаточно быстро, чтобы пользователь ничего не заметил.


    $wrapper.classList.add(wrapperAbsClass);
    $wrapper.scrollTop = scrTop; // NOTE: Это из-за плашки browser-update

    if (mtExists) {
      $document.scrollTop = 0;
    } // Это для отсутсвия скролла у <body> в некоторых редких случаях
    // (например, если висит плашка об устаревшем браузере)


    $body.classList.add(popupOpenedClass); // Здесь предусмотрена возможность автоматически скрывать некоторые всплывашки
    // при открытии других всплывашек.
    // Для этого им нужно задать определённый data- атрибут
    // (указан в локальных переменных в начале модуля).

    var autohidePopupsOpened = [].filter.call(autohidePopups, function (el) {
      return el.classList.contains("." + openedClass);
    });

    if (autohidePopupsOpened.length > 0) {
      DEBUG && console.log("[module popups] hided " + autohidePopupsOpened.length + " popups with " + dAttrAutohide + "=true");
      Array.prototype.forEach.call(autohidePopupsOpened, function (el) {
        el.classList.remove(openedClass);
      });
    }

    if (currentOpenedPopup) {
      currentOpenedPopup = undefined;
    } // Далее, делаем нашу всплывашку видимой (за счёт класса)


    self.classList.add(openedClass);
    currentOpenedPopup = self;
    var isIncludeSlider = self.hasAttribute("data-slider");

    if (isIncludeSlider) {
      if (self.getAttribute("data-slider") !== "true") {
        var sliderContainer = self.querySelector(".js-slider");
        self.setAttribute("data-slider", "true");
        itsoftApp.modules.slidersLibrary.callback(sliderContainer, self.getAttribute("data-slider-name"), currentSlide);
      } else {
        itsoftApp.modules.slidersLibrary.slider[self.getAttribute("data-slider-name")].slideTo(+currentSlide);
      }
    }

    if (self.hasAttribute("data-destroy-device")) {
      var onWindowResize = function onWindowResize() {
        if (itsoftApp.utils.getViewportSize() >= BREAKPOINT[self.getAttribute("data-destroy-device")]) {
          self.dispatchEvent(closeEvent);
          window.removeEventListener("resize", onWindowResize);
        }
      };

      window.addEventListener("resize", onWindowResize);
    } // Здесь предусмотрена возможность
    // закрыть текущую всплывашку через определённый промежуток времени
    // (например, всплывашка с которким информационным сообщением).
    // Для этого им нужно задать определённый data- атрибут
    // (указан в локальных переменных в начале модуля).


    var hideDelay = self.getAttribute(dAttrHide);

    if (hideDelay) {
      hideDelay = parseInt(hideDelay, 10);
      hideDelay = isNaN(hideDelay) ? hideDelayDefault : hideDelay;
      setTimeout(function () {
        self.dispatchEvent(closeEvent);
      }, hideDelay);
    } // При необходимости, можно управлять адресной строкой браузера


    var urlToChange = self.getAttribute(dAttrUrl);

    if (urlToChange) {
      changePageUrl(urlToChange);
    }

    DEBUG && console.log("[module popups] opened popup: " + (self.id ? "#" + self.id : "." + self.className));
  };
  /**
   * Возврат страницы к исходному
   * (до того, как была открыта хоть одна всплывшка)
   * состоянию.
   *
   * @param  {boolean} force Часть функционала можно исполнить принудительно
   */


  var clearScrollStyles = function clearScrollStyles(force) {
    if (force == null) {
      force = false;
    } // Функция выполнится, если не осталось открытых всплывашек
    // (потому что их может быть несколько, и закрытие одной не означает закрытие всех),
    // либо принудительно (в редких случаях).


    var hasOpenedPopups = getOpenedPopups().length > 0;

    if (hasOpenedPopups && !force) {
      return;
    } // Вычисляем текущую величину прокрутки страницы
    // (функция getScrTop достаточно "умная", чтобы посчитать текущий скролл при любом состоянии).
    // Это нужно сделать до того, как произойдут дальнейшие действия.
    // $wrapper.classList.add(wrapperOverflow);


    var scrTop = getScrTop();
    DEBUG && console.log("%c[module popups] (clearScrollStyles) scrTop: " + scrTop + ". force: " + force, "color: #999"); // $wrapper.classList.remove(wrapperOverflow);
    // Возвращаем структурные элементы .l-wrapper и body
    // к исходному состоянию, убираем все необходимые классы.

    $wrapper.classList.remove(wrapperAbsClass);
    $body.classList.remove(popupOpenedClass); // Если на странице есть fixed элементы,
    // то убираем ранее заданное значение radding-right

    if (hasFixedElems) {
      Array.prototype.forEach.call(fixedPageElems, function (el) {
        el.style.paddingRight = "";
      });
    } // NOTE: Это из-за плашки browser-update


    var mt = parseInt(getComputedStyle($document)["marginTop"], 10);
    var mtExists = !isNaN(mt) && mt !== 0;

    if (mtExists) {
      scrTop += mt;
    } // // Наконец, пролистываем body до того значения,
    // // который был у .l-wrapper.
    // // Происходит это довольно быстро, так что пользователь не заметит разницы.


    $document.scrollTop = scrTop;
  };
  /**
   * Все действия, связанные с закрытием всплывашки
   */


  var popupClose = function popupClose() {
    var self = this;

    if (!self.classList.contains(openedClass)) {
      return;
    }

    if (activeButton) {
      /* ??? */
      activeButton.classList.remove("js-active");
      activeButton = undefined;
    }
    /* ??? */


    self.classList.remove(openedClass); // Так как вплывашка прилетает не мгновенно, а плавно,
    // то сразу делать возврат страницы к исходному состоянию нельзя
    // (будут видны артефакты, сязанные с переводом полосы прокрутки
    // от body к .l-wrapper и обратно).

    var end = function end() {
      setTimeout(function () {
        clearScrollStyles();
      }, 200);

      if (transitionEventEnd) {
        self.removeEventListener(transitionEventEnd, end);
      }
    }; // Для современных браузеров, где работает свойство transition,
    // вешаем обработчик на событие transitionEnd.


    if (transitionEventEnd) {
      self.addEventListener(transitionEventEnd, end); // Для старых браузеров, сразу вызываем функцию.
    } else {
      end();
    } // При необходимости,
    // меняем (возвращаем обратно)
    // адрес в строке браузера.


    var urlToChange = self.getAttribute(dAttrUrl);
    var popupID = self.id;

    if (urlToChange) {
      changePageUrl("back", popupID);
    }

    DEBUG && console.log("[module popups] closed popup: " + (self.id ? "#" + self.id : "." + self.className));
  };
  /**
   * Обработчик события "click", который определяет,
   * по какому именно мы кликнули элементу, и, если это
   * "пустое пространство" за самой всплывахой,
   * то закрываем её.
   *
   * NOTE: Можно отменить данное действие, задав дополнительный data- атрибут
   *
   * @param  {object} e Event
   */


  var popupClick = function popupClick(evt) {
    var self = this;

    if (evt.target === self && self.getAttribute(dAttrBgClose) !== "false") {
      self.dispatchEvent(closeEvent);
    }
  };
  /**
   * Клик по кнопкам, открывающим всплывахи.
   * Какую именно всплывашку открыть - обозначено в data- атрибуте.
   */


  var openPopupBtnClick = function openPopupBtnClick(evt) {
    evt.preventDefault();
    var self = this;
    var dataSlide = self.getAttribute("data-slide");
    var selector = self.getAttribute(dAttrSelector);
    var popup = [].filter.call(popups, function (el) {
      return el.matches(selector);
    })[0];
    dataSlide ? currentSlide = dataSlide : currentSlide = undefined;
    popup.dispatchEvent(openEvent);
    var closePopupSelector = self.getAttribute(dAttrClose);
    activeButton = this;
    /* ??? */

    if (closePopupSelector) {
      var popupToClose = document.querySelectorAll(closePopupSelector);
      /* ??? all*/

      Array.prototype.forEach.call(popupToClose, function (el) {
        el.dispatchEvent(closeEvent);
      });
    }
  };
  /**
   * Клик по кнопкам, закрывающим всплывашку.
   * Будет закрыта "родительская" всплывашка
   * (поиск по ближайшему родителю с нужным классом).
   */


  var closePopupBtnClick = function closePopupBtnClick() {
    var self = this;
    var popup = self.closest("." + popupClass);

    var onBoxCheck = function onBoxCheck(evt) {
      if (evt.currentTarget.classList.contains("js-error")) {
        checkbox.classList.remove("js-error");
        checkbox.removeEventListener("change", onBoxCheck);
      }
    };

    if (this.classList.contains("js-save")) {
      if (self.hasAttribute("data-checkbox")) {
        var checkboxID = self.getAttribute("data-checkbox");
        var checkbox = confirmation.querySelector(checkboxID);

        if (!checkbox.checked) {
          checkbox.classList.remove("js-error");
          checkbox.addEventListener("change", onBoxCheck);
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              checkbox.classList.add("js-error");
            });
          });
          return;
        }
      }

      itsoftApp.modules.cookie.setCookie(this);
    }

    popup.dispatchEvent(closeEvent);
  };
  /**
   * Так как прокрутку страницы мы "отменяем" хитрым способом,
   * то при попытке перезагрузить страницу, на которой уже открыта всплывашка,
   * нас перекинет наверх страницы.
   * Это подбешивает, поэтому привязываем данную функцию на событие закрытия (обновления)
   * страницы. Мы принудительно возвращаем страницу к её исходному состоянию,
   * тем самым нас не перекинет наверх после перезагрузки.
   */


  var windowUnload = function windowUnload() {
    clearScrollStyles(true);
  };
  /**
   * Обработчик нажатий на кнопки клавиатуры.
   * Необходим для того, чтобы можно было закрыть всплывашку кнопкой ESC.
   *
   * NOTE: Так как возможны случаи, когда открыто несколько всплывах,
   * то закрываем их одна за одной, начиная с той, у которой наибольший z-index.
   *
   * @param  {object} e Event
   */


  var keyController = function keyController(evt) {
    // Обрабатываем только нажатие на ESC,
    // а все остальные нажатия игнорируем.
    if (evt.keyCode !== 27) {
      return;
    }

    var openedPopups = getOpenedPopups();

    if (!openedPopups.length) {
      return;
    }

    var maxZI = 0;
    var lastOpenedPopup = undefined;
    Array.prototype.forEach.call(openedPopups, function (el) {
      var popup = el;
      var zi = parseInt(getComputedStyle(popup)["zIndex"], 10);

      if (isNaN(zi)) {
        zi = 0;
      }

      if (zi >= maxZI) {
        maxZI = zi;
        lastOpenedPopup = popup;
      }
    });

    if (!lastOpenedPopup) {
      return;
    } // Закрываем только последнюю открытую всплывашку


    if (!lastOpenedPopup.hasAttribute("data-save")) {
      lastOpenedPopup.dispatchEvent(closeEvent);
    }
  };

  if (window.CustomEvent && typeof window.CustomEvent === "function") {
    window.closeEvent = new CustomEvent(evNameClose, {
      detail: {
        name: "Закрытие"
      }
    });
    window.openEvent = new CustomEvent(evNameOpen, {
      detail: {
        name: "Открытие"
      }
    });
  } else {
    window.closeEvent = document.createEvent("CustomEvent");
    window.openEvent = document.createEvent("CustomEvent");
    closeEvent.initCustomEvent(evNameClose, true, true, {
      name: "Закрытие"
    });
    openEvent.initCustomEvent(evNameOpen, true, true, {
      name: "Открытие"
    });
  }

  Array.prototype.forEach.call(popups, function (popup) {
    popup.addEventListener(evNameOpen, popupOpen);
    popup.addEventListener(evNameClose, popupClose);
    popup.addEventListener("click", popupClick);
  });
  Array.prototype.forEach.call(openPopupBtns, function (openBtn) {
    openBtn.addEventListener("click", openPopupBtnClick);
  });
  Array.prototype.forEach.call(closePopupBtns, function (closeBtn) {
    closeBtn.addEventListener("click", closePopupBtnClick);
  });
  window.addEventListener("beforeunload", windowUnload);
  window.addEventListener("keyup", keyController);

  if (activePopups) {
    Array.prototype.forEach.call(activePopups, function (el) {
      var dAttrSave = el.getAttribute("data-save");

      if (dAttrSave && !itsoftApp.modules.cookie.getCookie(el)) {
        el.dispatchEvent(openEvent);
      } else if (!dAttrSave) {
        el.dispatchEvent(openEvent);
      } else {
        el.dispatchEvent(closeEvent);
      }
    });
  }

  if (disabledButtons) {
    Array.prototype.forEach.call(disabledButtons, function (el) {
      el.addEventListener("click", function (evt) {
        evt.preventDefault();
        confirmation.style.display = "none";
      });
    });
  } // Unit-tests


  if (DEBUG && typeof describe === "function") {
    describe("[module popups]", function () {
      it("all popups must be moved on <body> level", function () {
        popups.each(function () {
          expect(this.parentElement.nodeName.toLowerCase()).to.be.equal("body");
        });
      });
      it("each popup must have custom events: " + evNameOpen + " and " + evNameClose, function () {
        popups.each(function () {
          var obj = $._data(this, "events");

          expect(evNameOpen in obj).to.be.equal(true);
          expect(evNameClose in obj).to.be.equal(true);
        });
      });
    });
  }
});
"use strict";

itsoftApp.createModule("scrollAnimate", ["scrollEffects"], function () {
  var ScrollEffects = itsoftApp.modules.scrollEffects.ScrollEffects,
      fadeInElements = document.querySelectorAll(".fadeIn"),
      elementsInvisible = document.querySelectorAll(".js-invisible"); //анимация fadeIn элементов

  var initAnimation = function initAnimation() {
    for (var i = 0; i < fadeInElements.length; i++) {
      new ScrollEffects(fadeInElements[i], "fadeIn--show");
    }

    for (var j = 0; j < elementsInvisible.length; j++) {
      new ScrollEffects(elementsInvisible[j], "js-visible", "js-invisible");
    }
  };

  itsoftApp.modules.pageLoad.addEvent(initAnimation);
});
"use strict";

itsoftApp.createModule("scrollEffects", ["windowScroll"], function () {
  var module = this;

  function ScrollEffects(self, classAnimate, oldClass, obj, callBack) {
    this._self = self;
    this._classAnimate = classAnimate;
    this._obj = obj, this._callBack = callBack;
    this._scrollPoint;
    this._oldClass = oldClass;
    this.init();
  }

  ScrollEffects.prototype.init = function () {
    var self = this;

    function show(scroll, number) {
      var scrolled = pageYOffset;
      var coeff;

      if (number) {
        coeff = number;
      } else {
        coeff = 1.3;
      }

      self._scrollPoint = parseInt(self._self.getBoundingClientRect().top); // console.log(scrolled + window.innerHeight / 2  + " " + (self._scrollPoint + scrolled));

      if (scrolled + window.innerHeight / coeff >= self._scrollPoint + scrolled) {
        self.fadeIn();
      }
    }

    show("auto", 1);
    itsoftApp.modules.windowScroll.addEvent(show);
  };

  ScrollEffects.prototype.fadeIn = function () {
    if (typeof this._callBack === "function") {
      this._callBack.call(this._obj);
    } else {
      if (this._oldClass) {
        this._self.classList.remove(this._oldClass); // if (this._self.classList.contains("js-slider")) {
        //     itsoftApp.modules.slidersLibrary.callback(this._self);
        // }


        if (this._self.classList.contains("js-accordion")) {
          itsoftApp.modules.accordion.callback(this._self);
        }

        this._oldClass = undefined;
      }

      this._self.classList.add(this._classAnimate);
    }
  };

  module.ScrollEffects = ScrollEffects;
});
// /**
//  * Общий модуль для всех лисалок на сайте.
//  * Библиотека загружается по мере необходимости.
//  */
// itsoftApp.createModule("slidersLibrary", function() {
//     // Локальные переменные
//     var module = this;
//     var queue = [];
//     var libraryLoaded = false;
//     var loadingStarted = false;
//     /**
//      * Вызов всех функций, которые были добавлены
//      * в массив queue в процессе загрузки библиотеки
//      * (до этого момента их вызов привёл бы к ошибке).
//      */
//     var initQueue = function() {
//         if (!libraryLoaded) {
//             return false;
//         }
//         var qLen = queue.length;
//         if (!qLen) {
//             return;
//         }
//         DEBUG && console.log("[module slidersLibrary] initQueue function fired, queue.length: " + qLen);
//         while (queue.length > 0) {
//             // Взять первый элемент массива,
//             // и вызвать его. Мы уже знаем, что это функция,
//             // поэтому доп. проверка не требуется.
//             queue.shift()();
//         }
//     };
//     /**
//      * Загрузить библиотеку и выполнить
//      * отложенные функции из массива queue.
//      */
//     var loadAndInit = function() {
//         var f = function() {
//             libraryLoaded = true;
//             initQueue();
//         };
//         // Случай, если библиотека вдруг уже загружена
//         // (например, если она принудительна вставлена в html через <script>)
//         itsoftApp.loadStyle("assets/scripts/swiper/swiper.min.css");
//         itsoftApp.loadScript("assets/scripts/swiper/swiper.min.js", function() {
//             DEBUG && console.log("[module slidersLibrary] library loaded, ready to init queue");
//             f();
//         });
//     };
//     /**
//      * Добавление переданной функции в очередь на выполнение,
//      * либо немедленное исполнение функции, если библиотека уже загружена.
//      *
//      * @param {function} func
//      */
//     var addEvent = function(func) {
//         if (typeof func !== "function") {
//             return;
//         }
//         // Если библиотека ещё не загружена, то добавляем в очередь
//         if (!libraryLoaded) {
//             // Если библиотека ещё не начала грузиться, то загружаем её
//             // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
//             if (!loadingStarted) {
//                 loadingStarted = true;
//                 DEBUG && console.log("%c--[module slidersLibrary] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
//                 itsoftApp.modules.pageLoad.addEvent(loadAndInit);
//             }
//             queue.push(func);
//             DEBUG && console.log("[module slidersLibrary] function added, count of functions to init now: " + queue.length);
//         // Если библиотека уже загружена, то просто вызываем переданную функцию
//         } else {
//             func();
//         }
//     };
//     // Доступ к функциям
//     // текущего модуля
//     module.addEvent = addEvent;
//     var setSlider = function (el, settings, cb, name, currentSlide) {
//         var createSlider = function () {
//             var sliderContainer = el.querySelector(".swiper-container");
//             var navigation = el.querySelector(".swiper-navigation");
//             var pagination = el.querySelector(".swiper-pagination");
//             var scrollbar = el.querySelector(".swiper-scrollbar");
//             // var slideCount = el.getAttribute("data-slide-count");
//             var dataDevice = el.getAttribute("data-destroy-device");
//             var sliderName = sliderContainer.getAttribute("data-name");
//             var destroyDirection = el.getAttribute("data-destroy-direction");
//             var withoutNavigation = el.hasAttribute("data-without-navigation");
//             var withoutPagination = el.hasAttribute("data-without-pagination");
//             // var freeMode = el.getAttribute("data-free-mode");
//             // var dataGap = el.getAttribute("data-gap");
//             var isInitialized = false;
//             var initializedSlider;
//             var sliderSettings;
//             if (name) {
//                 var sliderName = name;
//             }
//             if (settings) {
//                 sliderSettings = settings;
//             } else {
//                 sliderSettings = {
//                     slidesPerView: 1,
//                     watchOverflow: true,
//                     loop: true,
//                     a11y: {
//                         firstSlideMessage: "",
//                         lastSlideMessage: ""
//                     },
//                     simulateTouch: true,
//                     keyboard: {
//                         enabled: true,
//                         onlyInViewport: true
//                     },
//                     thumbs: {
//                         swiper: {
//                             el: '.benefits__thumbs',
//                             slideClass: 'icon-benefits',
//                             slidesPerView: 'auto',
//                             followFinger: false,
//                         }
//                     },
//                     pagination: {
//                         clickable: true,
//                     },
//                 }
//                 if (sliderName) {
//                     sliderSettings.on = {
//                         init: function () {
//                             var swiper = this;
//                             module.sliders[sliderName] = swiper;
//                         }
//                     }
//                 }
//                 if (scrollbar) {
//                     sliderSettings.scrollbar = {
//                         el: scrollbar,
//                         draggable: true
//                     }
//                 }
//             }
//             if (!withoutNavigation && navigation) {
//                 var prevBtn = navigation.querySelector(".js-prev-btn");
//                 var nextBtn = navigation.querySelector(".js-next-btn");
//                 sliderSettings.navigation = {};
//                 sliderSettings.navigation.prevEl = prevBtn;
//                 sliderSettings.navigation.nextEl = nextBtn;
//             }
//             if (!withoutPagination && pagination) {
//                 sliderSettings.pagination = {};
//                 sliderSettings.pagination.el = pagination;
//                 if (pagination.classList.contains("js-pagination-dots")) {
//                     sliderSettings.pagination.type = "bullets";
//                     sliderSettings.pagination.clickable = "true";
//                 } else {
//                     sliderSettings.pagination.type = "fraction";
//                     sliderSettings.pagination.renderFraction = function (currentClass, totalClass) {
//                         return '<span class="' + currentClass + '"></span>' +
//                               '/' +
//                               '<span class="' + totalClass + '"></span>';
//                     }
//                 }
//             }
//             var destroySlider = function () {
//                 initializedSlider.destroy(false, true);
//                 initializedSlider = undefined;
//                 isInitialized = false;
//             }
//             var initSlider = function () {
//                 initializedSlider = new Swiper(sliderContainer, sliderSettings);
//                 if (initializedSlider) {
//                     if (sliderName) {
//                         module.slider[sliderName] = initializedSlider;
//                     }
//                     if (currentSlide) {
//                         initializedSlider.slideTo(+currentSlide);
//                     }
//                     isInitialized = true;
//                 }
//             }
//             var onWindowResize = function () {
//                 if (destroyDirection === "from" && dataDevice && itsoftApp.utils.getViewportSize() >= +dataDevice) {
//                     if (isInitialized === true) {
//                         destroySlider();
//                     }
//                 } else if (destroyDirection === "to" && dataDevice && itsoftApp.utils.getViewportSize() <= +dataDevice) {
//                     if (isInitialized === true) {
//                         destroySlider();
//                     }
//                 } else {
//                     if (isInitialized === false) {
//                         initSlider();
//                     }
//                 }
//             }
//             if (dataDevice) {
//                 onWindowResize();
//                 itsoftApp.modules.windowResize.addEvent(onWindowResize);
//             } else {
//                 initSlider();
//             }
//         }
//         if (el.hasAttribute("data-delay")) {
//             setTimeout(function () {
//                 addEvent(createSlider);
//             }, +(el.getAttribute("data-delay")));
//         } else {
//             addEvent(createSlider);
//         }
//     }
//     module.slider = {};
//     module.sliders = {};
//     module.callback = setSlider;
// });
"use strict";
// /**
//  * Модуль конфигов для слайдеров. Получаем объект, у которого ключ должен быть равен ключу
//  * переданному в дата-атрибут data-slider-settings="mainPageSlider" обертки с классом js-slider
//  * Таким образом можно управлять всеми конфигами в этом файле
//  */
// itsoftApp.createModule("slidersSettings", function () {
//     // Локальные переменные
//     var module = this;
//     module.sliderSettingsObject = {}
// });
"use strict";
// itsoftApp.createModule("toggleTabs", function() {
//     var module = this;
//     var tabs = document.querySelectorAll('.js-tabs-section');
//     var deletePopupHandler = function (el) {
//         if (el.classList.contains("js-open-popup")) {
//             el.classList.remove("js-open-popup");
//             el.removeAttribute("data-popup-selector");
//         }
//     }
//     var initTabToggle = function(tabs) {
//         var tabs = tabs;
//         var tabsContents = tabs.querySelectorAll(".js-tab-content");
//         var tabsItems = tabs.querySelectorAll(".js-tab-name");
//         var currentActiveTab = tabs.querySelector(".js-tab-name--active");
//         var currentActiveContent = tabs.querySelector(".js-tab-content--active");
//         var currentIndex;
//         var hash = location.hash;
//         var goToHash = function (newHash) {
//             var element;
//             var contentElement;
//             if (newHash) {
//                 var selector = "[data-tab-selector='" + newHash + "']";
//                 var contentSelector = "[data-content-url='" + newHash + "']";
//                 element = tabs.querySelector(selector);
//                 contentElement = tabs.querySelector(contentSelector);
//             } else {
//                 element = tabsItems[0];
//                 contentElement = tabsContents[0];
//             }
//             if (element) {
//                 goToTab(element, contentElement);
//             }
//         }
//         var goToTab = function (tab, content) {
//             deletePopupHandler(tab);
//             currentActiveTab.classList.remove("js-tab-name--active");
//             currentActiveContent.classList.remove("js-tab-content--active");
//             currentActiveTab = tab;
//             currentActiveContent = content;
//             currentActiveTab.classList.add("js-tab-name--active");
//             currentActiveContent.classList.add("js-tab-content--active");
//         }
//         var onTabClick = function (evt, index) {
//             if (evt.target.hasAttribute("data-tab-selector")) {
//                 location.hash = evt.target.getAttribute("data-tab-selector");
//             } else if (evt.currentTarget.hasAttribute("data-tab-selector")) {
//                 location.hash = evt.currentTarget.getAttribute("data-tab-selector");
//             }
//             currentIndex = index;
//             goToTab(tabsItems[currentIndex], tabsContents[currentIndex]);
//         }
//         var addTabClickListener = function (tab, index) {
//             tab.addEventListener("click", function (evt) {
//                 evt.preventDefault();
//                 onTabClick(evt, index);
//             });
//         }
//         for (var i = 0; i < tabsItems.length; i++) {
//             addTabClickListener(tabsItems[i], i);
//         }
//         if (location.hash) {
//             goToHash(location.hash);
//         } else {
//             deletePopupHandler(tabsItems[0]);
//         }
//         module.callback.goToHash = goToHash;
//     }
//     var initTabs = function () {
//         if (tabs) {
//             for (var i = 0; i < tabs.length; i++) {
//                 initTabToggle(tabs[i]);
//             }
//         }
//     }
//     module.callback = initTabs;
// })
"use strict";
"use strict";

/**
 * Общая точка входа
 * для события изменения размеров экрана.
 *
 * NOTE: Событие на практике происходит редко
 * (например, поворот планшета или телефона, или равзернуть окно на полный экран на десктопе),
 * поэтому мы будем "выполнять" его с помощью debouncer
 * (отложенное выполнение).
 */
itsoftApp.createModule("windowResize", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var $window = itsoftApp.commonVars.$window;
  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   *
   * Вызываем обработчик через debouncer (задержка по выполнению),
   * чтобы функции из массива не вызывались слишком часто.
   */

  var resizeController = itsoftApp.utils.debouncer(function () {
    if (!events.length) {
      return;
    }

    var f, i, len;

    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f();
    }
  });
  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "resize" окна браузера.
   *
   * @param {function} func
   */

  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }

    events.push(func);
    DEBUG && console.log("[module windowResize] function added, count of functions to init now: " + events.length);
  }; // Привязка события и обработчика


  $window.addEventListener("resize", resizeController); // Доступ к фукциям
  // текущего модуля

  module.addEvent = addEvent;
});
"use strict";

/**
 * Общая точка входа
 * для события скролла страницы.
 *
 * NOTE: Контроллер будет передавать текущее значение скролла
 * каждой из переданных в данный модуль функций.
 */
itsoftApp.createModule("windowScroll", function () {
  // Локальные переменные
  var module = this;
  var events = [];
  var enabled = false;
  var $window = itsoftApp.commonVars.$window;
  /**
   * Основной обработчик,
   * который проходит по всем функциям из массива events
   * и выполняет их.
   */

  var scrollController = function scrollController() {
    if (!enabled) {
      return;
    }

    var y = document.body.scrollTop || document.documentElement.scrollTop;
    var f, i, len;

    for (i = 0, len = events.length; i < len; i++) {
      f = events[i];
      f.call(this, y);
    }
  };
  /**
   * Привязка события и контроллера.
   * Вынесено в отдельную функцию, так как если модулю не передана ни одна функция на событие "scroll"
   * то и общий обработчик вешать нет смысла.
   * Сделано для оптимизации производительности (небольшая прибавка).
   */


  var bind = function bind() {
    $window.addEventListener("scroll", scrollController);
  };
  /**
   * Добавление переданной функции в массив всех функций,
   * которые будут вызваны при срабатывании события "scroll".
   *
   * @param {function} func
   */


  var addEvent = function addEvent(func) {
    if (typeof func !== "function") {
      return;
    }

    if (!enabled) {
      enabled = true;
      bind();
    }

    events.push(func);
    DEBUG && console.log("[module windowScroll] function added, count of functions to init now: " + events.length);
  }; // Доступ к фукциям
  // текущего модуля


  module.addEvent = addEvent;
});